"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2441],{

/***/ 57315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93293);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n        a {\n          cursor: ",
        ";\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: #eeeeee;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n  a {\n    width: 100%;\n    height: 100%;\n  }\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n  &[data-type='channel'] {\n    border-radius: 5px;\n    border: 1px solid #dddddd;\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var defaultImageSrc = {
    channel: "/static/images/channel/enterprise.png",
    user: "/static/images/channel/user-profile.png"
};
var Avatar = function(param) {
    var _type = param.type, type = _type === void 0 ? "user" : _type, src = param.src, _href = param.href, href = _href === void 0 ? "" : _href, _size = param.size, size = _size === void 0 ? 36 : _size, _enableNextImage = param.enableNextImage, enableNextImage = _enableNextImage === void 0 ? false : _enableNextImage, className = param.className;
    var defaultSrc = defaultImageSrc[type];
    var fallbackImageProps = (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .useFallbackImageInSSR */ .DN)(defaultSrc);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        "data-type": type,
        customCss: (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), size, size, href ? "pointer" : "default"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: href,
            scroll: !!href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                children: enableNextImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    src: src || defaultSrc,
                    alt: "",
                    width: size,
                    height: size
                }, fallbackImageProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    src: src || defaultSrc,
                    alt: "avatar"
                }, fallbackImageProps))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Avatar__StyledWrapper",
    componentId: "sc-cefd5772-0"
})(_templateObject1(), function(param) {
    var customCss = param.customCss;
    return customCss;
});


/***/ }),

/***/ 55282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Editor_NewsEditor; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/components/FileUploadDialog.tsx
var FileUploadDialog = __webpack_require__(1530);
// EXTERNAL MODULE: ./src/constants/mimeTypes.ts
var constants_mimeTypes = __webpack_require__(13276);
// EXTERNAL MODULE: ./node_modules/react-material-ui-carousel/dist/index.js
var dist = __webpack_require__(13056);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
;// CONCATENATED MODULE: ./src/app.components/Editor/components/ImageContentViewer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  & .fit-image {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    object-position: center center;\n  }\n\n  & .image-preview-close-icon {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    width: 28px;\n    height: 28px;\n    opacity: 0.75;\n\n    & g {\n      fill: #333;\n      stroke: #333;\n    }\n\n    & path {\n      fill: white;\n    }\n\n    &:hover {\n      cursor: pointer;\n      opacity: 0.25;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ImageContentViewer = function(param) {
    var imageSrcList = param.imageSrcList, onDelete = param.onDelete, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                timeout: 0,
                cycleNavigation: false,
                autoPlay: false,
                navButtonsAlwaysVisible: imageSrcList.length > 1,
                indicators: imageSrcList.length > 1,
                className: className,
                children: imageSrcList.map(function(imageSrc, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: imageSrc,
                        className: "fit-image",
                        alt: "editor image"
                    }, "".concat(imageSrc, "-").concat(index));
                })
            }),
            !!onDelete && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* CloseCircle */.Pb, {
                onClick: onDelete,
                className: "image-preview-close-icon"
            })
        ]
    });
};
/* harmony default export */ var components_ImageContentViewer = (ImageContentViewer);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageContentViewer__StyledWrapper",
    componentId: "sc-250d73a8-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
;// CONCATENATED MODULE: ./src/svgIcons/PictureOff.tsx




var PictureOffIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "사진 비활성화"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "사진 비활성화"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h20v20H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                stroke: "#ccc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "15",
                        height: "11",
                        x: "2.5",
                        y: "5",
                        stroke: "none",
                        rx: "2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "10",
                        x: "3",
                        y: "5.5",
                        rx: "1.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#ccc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10 7.5H2a.491.491 0 01-.447-.276A.491.491 0 011.6 6.7l4-5.333a.496.496 0 01.4-.2c.159 0 .305.073.4.2l4 5.333a.49.49 0 01.047.524A.491.491 0 0110 7.5z",
                        transform: "translate(2.5 8)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6 1.667L2 7h8L6.002 1.667zm0-1c.3 0 .6.133.8.4l4 5.333A1 1 0 0110 8H2a1 1 0 01-.8-1.6l4-5.333c.2-.267.5-.4.8-.4z",
                        transform: "translate(2.5 8)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.08 4.5H1.92a.49.49 0 01-.443-.27.492.492 0 01.034-.517l1.58-2.256a.494.494 0 01.409-.213c.165 0 .315.078.41.213l1.579 2.256c.109.156.122.35.034.518a.492.492 0 01-.444.269z",
                        transform: "translate(10.5 11)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.5 1.744L1.92 4h3.16zm0-1c.31 0 .62.142.82.426l1.579 2.257A1 1 0 015.079 5H1.921a1 1 0 01-.82-1.573l1.58-2.257A.993.993 0 013.5.744z",
                        transform: "translate(10.5 11)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12.5",
                        cy: "8.5",
                        r: "0.5"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PictureOff = (PictureOffIcon);

;// CONCATENATED MODULE: ./src/svgIcons/Tag.tsx




var TagIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "태그"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "태그"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h20v20H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                fill: "#555"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeWidth: "1.2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.359 8.635h7.282M11.366 6.36v7.282M6.359 11.365h7.282M8.635 6.359v7.282"
                })
            })
        ]
    }));
};
/* harmony default export */ var Tag = (TagIcon);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/app.components/Editor/components/Chip/CustomChip.tsx








var CustomChip = function(_param) {
    var color = _param.color, classesOfProps = _param.classes, deleteIcon = _param.deleteIcon, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "classes",
        "deleteIcon",
        "className"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, (0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className, (0,_define_property/* default */.Z)({}, classes.primaryColorRoot, color === "primary")),
        classes: (0,_object_spread/* default */.Z)({
            deleteIcon: (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, classes.primaryColorDeleteIcon, color === "primary"), classesOfProps === null || classesOfProps === void 0 ? void 0 : classesOfProps.deleteIcon)
        }, classesOfProps),
        deleteIcon: deleteIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
    }, props));
};
/* harmony default export */ var Chip_CustomChip = (CustomChip);
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            backgroundColor: "#fdfdfd",
            border: "1px solid #dddddd"
        },
        primaryColorRoot: {
            backgroundColor: "#f0fcff",
            border: "1px solid ".concat(theme.palette.primary.main),
            color: theme.palette.primary.main
        },
        primaryColorDeleteIcon: {
            color: theme.palette.primary.main
        }
    };
});

;// CONCATENATED MODULE: ./src/app.components/Editor/components/Chip/index.tsx


;// CONCATENATED MODULE: ./src/app.components/Editor/components/RecommendTags.tsx

function RecommendTags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  & .chip {\n    transition-property: all;\n    &:hover {\n      background-color: #f0fcff;\n      color: #01a0ff;\n    }\n  }\n"
    ]);
    RecommendTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RecommendTags = function(param) {
    var tags = param.tags, onClickTag = param.onClickTag;
    var handleChipClick = function(tag) {
        onClickTag(tag);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendTags_StyledWrapper, {
        children: tags.map(function(tag) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_CustomChip, {
                color: tag.isActive ? "primary" : "default",
                label: "#".concat(tag.name),
                className: "chip",
                onClick: function() {
                    handleChipClick(tag);
                }
            }, "recommend-tag-".concat(tag.name));
        })
    });
};
/* harmony default export */ var components_RecommendTags = (RecommendTags);
var RecommendTags_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RecommendTags__StyledWrapper",
    componentId: "sc-5a82f632-0"
})(RecommendTags_templateObject());

;// CONCATENATED MODULE: ./src/app.components/Editor/components/ModalRecommendTags.tsx


function ModalRecommendTags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ModalRecommendTags_tag on Tag {\n    id\n    name\n  }\n  fragment ModalRecommendTags_tagConnection on TagConnection {\n    nodes {\n      ...ModalRecommendTags_tag\n    }\n  }\n  fragment ModalRecommendTags_tagCollection on TagCollection {\n    id\n    title\n    tags {\n      ...ModalRecommendTags_tagConnection\n    }\n  }\n\n  query ModalRecommendTags {\n    recommendNewsItemTagCollection {\n      ...ModalRecommendTags_tagCollection\n    }\n  }\n"
    ]);
    ModalRecommendTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 700px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  border-radius: 15px;\n\n  .recommend-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 32px;\n    font-size: 24px;\n    font-weight: 700;\n    border-bottom: 1px solid #dddddd;\n  }\n\n  .close-button {\n    position: absolute;\n    top: 32px;\n    right: 32px;\n    width: 16px;\n    height: 16px;\n    :hover {\n      cursor: pointer;\n    }\n  }\n\n  .tag-list-wrapper {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    border: 1px solid #dddddd;\n    border-radius: 5px;\n    margin-top: 12px;\n    padding: 20px;\n    width: 100%;\n    max-height: 213px;\n    overflow-y: scroll;\n  }\n\n  .recommend-content {\n    padding: 40px;\n\n    max-height: 600px;\n    overflow-y: scroll;\n\n    .head {\n      font-size: 20px;\n      font-weight: 700;\n    }\n\n    .loading-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-top: 32px;\n    }\n\n    .tag-group-wrapper {\n      display: flex;\n      flex-direction: column;\n      gap: 28px;\n      margin-top: 32px;\n\n      .title {\n        font-size: 16px;\n        font-weight: 500;\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  .recommend-footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid #dddddd;\n    padding: 20px 32px 32px;\n    .button {\n      width: 87px;\n      height: 48px;\n      font-size: 16px;\n      color: #fff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











src_default()(ModalRecommendTags_templateObject());
var ModalRecommendTags = function(param) {
    var onClose = param.onClose, onApply = param.onApply;
    var ref;
    var ref1 = (0,graphql/* useModalRecommendTagsQuery */.ui_)(), data = ref1.data, loading = ref1.loading;
    var ref2 = (0,react.useState)([]), tagList = ref2[0], setTagList = ref2[1];
    var handleTagClick = function(tag) {
        setTagList(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                tag.name
            ]);
        });
    };
    var handleTagDelete = function(index) {
        setTagList(function(prev) {
            var newTagList = (0,_to_consumable_array/* default */.Z)(prev);
            newTagList.splice(index, 1);
            return newTagList;
        });
    };
    var handleApplyButtonClick = function() {
        onApply(tagList);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        onClose: onClose,
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalRecommendTags_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "recommend-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "추천태그 선택"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                            className: "close-button",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "recommend-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "head",
                            children: "*연관있는 태그를 추가해 소식을 더 효과적으로 노출하세요."
                        }),
                        tagList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag-list-wrapper",
                            children: tagList.map(function(tag, tagIndex) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_CustomChip, {
                                    color: "primary",
                                    label: "#".concat(tag),
                                    onDelete: function() {
                                        handleTagDelete(tagIndex);
                                    }
                                }, "recommend-tag-item-".concat(tagIndex));
                            })
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tag-group-wrapper",
                            children: data === null || data === void 0 ? void 0 : (ref = data.recommendNewsItemTagCollection) === null || ref === void 0 ? void 0 : ref.map(function(tagCollection) {
                                if (tagCollection.tags.nodes.length === 0) {
                                    return null;
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "title",
                                            children: tagCollection.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RecommendTags, {
                                            tags: tagCollection.tags.nodes.map(function(node) {
                                                return {
                                                    name: node.name
                                                };
                                            }),
                                            onClickTag: handleTagClick
                                        })
                                    ]
                                }, "tag-group-".concat(tagCollection.title));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "recommend-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "primary",
                        onClick: handleApplyButtonClick,
                        disabled: tagList.length === 0,
                        className: "button",
                        children: "적용"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ModalRecommendTags = (ModalRecommendTags);
var ModalRecommendTags_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModalRecommendTags__StyledWrapper",
    componentId: "sc-95021320-0"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/app.components/Editor/components/NewsEditorActions.tsx

function NewsEditorActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .button {\n    height: 46px;\n    color: #333;\n    padding: 0 15px;\n  }\n\n  & .picture-icon {\n    & g:nth-of-type(1) {\n      stroke: #555;\n    }\n    & g:nth-of-type(2) {\n      fill: #555;\n    }\n  }\n\n  & > *:nth-child(n + 2) {\n    margin-left: 8px;\n  }\n"
    ]);
    NewsEditorActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var NewsEditorActions = function(param) {
    var fileUploadDialogId = param.fileUploadDialogId, _pictureButtonDisabled = param.pictureButtonDisabled, pictureButtonDisabled = _pictureButtonDisabled === void 0 ? false : _pictureButtonDisabled, onApplyTags = param.onApplyTags, className = param.className;
    var ref = (0,react.useState)(false), modalVisible = ref[0], setModalVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsEditorActions_StyledWrapper, {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        id: "uppy-file-upload-trigger-".concat(fileUploadDialogId),
                        disabled: pictureButtonDisabled,
                        color: "grey",
                        variant: "outlined",
                        className: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PictureOff, {
                                className: "picture-icon"
                            }),
                            "사진"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: function() {
                            return setModalVisible(true);
                        },
                        variant: "outlined",
                        className: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {}),
                            "추천태그"
                        ]
                    })
                ]
            }),
            modalVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalRecommendTags, {
                onClose: function() {
                    return setModalVisible(false);
                },
                onApply: onApplyTags
            })
        ]
    });
};
/* harmony default export */ var components_NewsEditorActions = (NewsEditorActions);
var NewsEditorActions_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsEditorActions__StyledWrapper",
    componentId: "sc-91475e3f-0"
})(NewsEditorActions_templateObject());

;// CONCATENATED MODULE: ./src/app.components/Editor/components/OpenGraphPreview/OpenGraphPreview.tsx
// import { openInNewTab } from 'modules/utils/router'

function OpenGraphPreview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    background-color: #f5fafd;\n\n    .content-root {\n      display: flex;\n      flex-direction: ",
        ";\n      ",
        "\n      :hover {\n        cursor: pointer;\n      }\n    }\n\n    .image {\n      ",
        "\n    }\n\n    .description-root {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      ",
        "\n    }\n\n    .og-close-button {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      width: 28px;\n      height: 28px;\n      opacity: 0.75;\n\n      g {\n        fill: #333;\n        stroke: #333;\n      }\n\n      path {\n        fill: white;\n      }\n\n      :hover {\n        cursor: pointer;\n        opacity: 0.25;\n      }\n    }\n\n    .description {\n      display: -webkit-box;\n      font-size: 15px;\n      line-height: 24px;\n      text-align: left;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      padding-right: 30px;\n    }\n\n    .domain {\n      font-size: 12px;\n      color: #999;\n    }\n  "
    ]);
    OpenGraphPreview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OpenGraphPreview_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    OpenGraphPreview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var OpenGraphPreview = function(param) {
    var imageSrc = param.imageSrc, description = param.description, domain = param.domain, url = param.url, onClose = param.onClose, className = param.className;
    var imageRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), fullSizeImage = ref[0], setFullSizeImage = ref[1];
    var handleClick = function() {
        if (window) {
            var ref;
            (ref = window.open(url, "_blank", "noopener noreferrer")) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    (0,react.useEffect)(function() {
        if (imageRef.current) {
            imageRef.current.addEventListener("load", function() {
                var ref;
                var isFullSizeImage = (((ref = imageRef.current) === null || ref === void 0 ? void 0 : ref.naturalWidth) || 0) > 600;
                setFullSizeImage(isFullSizeImage);
            });
        }
    }, [
        imageSrc,
        imageRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGraphPreview_StyledWrapper, {
        fullSizeImage: fullSizeImage,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-root",
                onClick: handleClick,
                children: [
                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        ref: imageRef,
                        src: imageSrc,
                        className: "image",
                        alt: "og image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "description-root",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "domain",
                                children: domain
                            })
                        ]
                    })
                ]
            }),
            onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* CloseCircle */.Pb, {
                className: "og-close-button",
                onClick: onClose
            })
        ]
    });
};
/* harmony default export */ var OpenGraphPreview_OpenGraphPreview = (OpenGraphPreview);
var OpenGraphPreview_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OpenGraphPreview__StyledWrapper",
    componentId: "sc-b0504ebf-0"
})(OpenGraphPreview_templateObject1(), function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(OpenGraphPreview_templateObject(), props.fullSizeImage ? "column" : "row", !props.fullSizeImage && "\n      padding: 20px;\n    ", !props.fullSizeImage && "\n      margin-right: 14px;\n      width: 134px;\n      height: auto;\n    ", props.fullSizeImage && "\n      padding: 20px;\n    ");
});

;// CONCATENATED MODULE: ./src/app.components/Editor/components/OpenGraphPreview/index.tsx


// EXTERNAL MODULE: ./src/style/palette.ts
var palette = __webpack_require__(18856);
// EXTERNAL MODULE: ./src/svgIcons/ErrorIcon.tsx
var ErrorIcon = __webpack_require__(46095);
;// CONCATENATED MODULE: ./src/app.components/Editor/components/HelperTextWithIcon.tsx





var STYLE_VALUE_OF_COLOR = {
    primary: {
        color: palette/* default.primary.main */.Z.primary.main,
        iconColor: palette/* default.primary.main */.Z.primary.main
    },
    error: {
        color: palette/* default.error.light */.Z.error.light,
        iconColor: palette/* default.error.light */.Z.error.light
    },
    text: {
        color: palette/* default.text.primary */.Z.text.primary,
        iconColor: "#707070"
    },
    hint: {
        color: palette/* default.text.hint */.Z.text.hint,
        iconColor: palette/* default.text.hint */.Z.text.hint
    }
};
var HelperTextWithIcon = function(param) {
    var text = param.text, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon/* default */.Z, {}) : _icon, _color = param.color, color = _color === void 0 ? "primary" : _color, className = param.className;
    var classes = useStyle(STYLE_VALUE_OF_COLOR[color]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classes.helperText,
                children: text
            })
        ]
    });
};
/* harmony default export */ var components_HelperTextWithIcon = (HelperTextWithIcon);
var useStyle = (0,makeStyles/* default */.Z)(function() {
    return {
        root: {
            display: "flex",
            alignItems: "center",
            color: function(param) {
                var color = param.color;
                return color;
            },
            fontWeight: 500,
            "& > svg > path": {
                fill: function(param) {
                    var iconColor = param.iconColor;
                    return iconColor;
                }
            }
        },
        helperText: {
            marginLeft: 6
        }
    };
});

;// CONCATENATED MODULE: ./src/app.components/Editor/components/OpenGraphPreview/OpenGraphPreviewError.tsx

function OpenGraphPreviewError_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  background-color: #f5fafd;\n"
    ]);
    OpenGraphPreviewError_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var OpenGraphPreviewError = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenGraphPreviewError_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HelperTextWithIcon, {
            color: "error",
            text: "미리보기를 표시할 수 없습니다. 미리보기 없이 올리시거나 다른링크를 이용하세요."
        })
    });
};
/* harmony default export */ var OpenGraphPreview_OpenGraphPreviewError = (OpenGraphPreviewError);
var OpenGraphPreviewError_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OpenGraphPreviewError__StyledWrapper",
    componentId: "sc-e2efdbdc-0"
})(OpenGraphPreviewError_templateObject());

// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
;// CONCATENATED MODULE: ./src/app.components/Editor/components/OpenGraphPreview/OpenGraphPreviewLoading.tsx

function OpenGraphPreviewLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  background-color: #f5fafd;\n\n  & .gap {\n    margin-top: 6px;\n  }\n\n  & .bottom {\n    margin-top: 20px;\n  }\n"
    ]);
    OpenGraphPreviewLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var OpenGraphPreviewLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGraphPreviewLoading_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 350,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 200,
                height: 16,
                className: "gap"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 80,
                height: 13,
                className: "bottom"
            })
        ]
    });
};
/* harmony default export */ var OpenGraphPreview_OpenGraphPreviewLoading = (OpenGraphPreviewLoading);
var OpenGraphPreviewLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OpenGraphPreviewLoading__StyledWrapper",
    componentId: "sc-60d98d43-0"
})(OpenGraphPreviewLoading_templateObject());

// EXTERNAL MODULE: ./src/app.components/Editor/components/WriterInfo.tsx
var WriterInfo = __webpack_require__(60125);
// EXTERNAL MODULE: ./src/app.components/Editor/modules/constants/hashtag.ts
var hashtag = __webpack_require__(41542);
;// CONCATENATED MODULE: ./src/app.components/Editor/modules/editor.ts
var getEditorLength = function(delta, oldDelta) {
    var ref, ref1;
    var calculatedOldTextLengthList = (ref = oldDelta.ops) === null || ref === void 0 ? void 0 : ref.map(function(op) {
        var ref;
        if (op === null || op === void 0 ? void 0 : (ref = op.insert) === null || ref === void 0 ? void 0 : ref.hashtag) {
            return op.insert.hashtag.length - 1;
        }
        if (op === null || op === void 0 ? void 0 : op.insert) {
            return op.insert.trim().replace("\n", "").length;
        }
        return 0;
    });
    var oldTextLength = calculatedOldTextLengthList === null || calculatedOldTextLengthList === void 0 ? void 0 : calculatedOldTextLengthList.reduce(function(acc, cur) {
        return acc + cur;
    }, 0);
    var calculatedTextLengthList = (ref1 = delta.ops) === null || ref1 === void 0 ? void 0 : ref1.map(function(op) {
        var ref;
        if (op === null || op === void 0 ? void 0 : (ref = op.insert) === null || ref === void 0 ? void 0 : ref.hashtag) {
            return op.insert.hashtag.length - 1;
        }
        if (op === null || op === void 0 ? void 0 : op.insert) {
            return op.insert.trim().replace("\n", "").length;
        }
        if (op === null || op === void 0 ? void 0 : op.delete) {
            return op.delete * -1;
        }
        return 0;
    });
    var insertTextLength = calculatedTextLengthList === null || calculatedTextLengthList === void 0 ? void 0 : calculatedTextLengthList.reduce(function(acc, cur) {
        return acc + cur;
    }, 0);
    var ref2;
    var textLength = (ref2 = oldTextLength + insertTextLength) !== null && ref2 !== void 0 ? ref2 : 0;
    return textLength;
};

;// CONCATENATED MODULE: ./src/app.components/Editor/NewsEditor.tsx






function NewsEditor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsEditor_attachment on Attachment {\n    id\n    url\n  }\n  fragment NewsEditor_organization on Organization {\n    id\n    logoImage {\n      ...NewsEditor_attachment\n    }\n  }\n  fragment NewsEditor_channel on Channel {\n    id\n    name\n    owner {\n      ...NewsEditor_organization\n    }\n  }\n  fragment NewsEditor_user on User {\n    id\n    channel {\n      ...NewsEditor_channel\n    }\n  }\n\n  query NewsEditor {\n    currentUser {\n      ...NewsEditor_user\n    }\n  }\n"
    ]);
    NewsEditor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsEditor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  .scroll-wrapper {\n    max-height: 434px;\n    overflow-y: scroll;\n    padding-right: 40px;\n    @media screen and (max-height: 750px) {\n      max-height: 400px;\n    }\n    @media screen and (max-height: 700px) {\n      max-height: 350px;\n    }\n    @media screen and (max-height: 650px) {\n      max-height: 300px;\n    }\n    @media screen and (max-height: 600px) {\n      max-height: 250px;\n    }\n  }\n\n  .writer-info {\n    margin-bottom: 12px;\n  }\n\n  .og-preview-wrapper {\n    margin-top: 24px;\n    margin-bottom: 8px;\n  }\n\n  .actions {\n    width: 100%;\n    padding-top: 8px;\n    background-color: white;\n  }\n\n  .overflow-helper-text {\n    color: #ef2929;\n    font-size: 14px;\n    padding-top: 8px;\n  }\n"
    ]);
    NewsEditor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var Editor = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2937), __webpack_require__.e(3830), __webpack_require__.e(6413)]).then(__webpack_require__.bind(__webpack_require__, 96413));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96413)
            ];
        }
    },
    ssr: false
});
var EditorWithForwardedRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        forwardedRef: ref
    }));
});
var FILE_UPLOAD_ID = "news-picture-dialog";
src_default()(NewsEditor_templateObject());
var NewsEditor = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var setIsCanSubmit = param.setIsCanSubmit, setIsDirty = param.setIsDirty, _pictureMaxSizeMb = param.pictureMaxSizeMb, pictureMaxSizeMb = _pictureMaxSizeMb === void 0 ? 10 : _pictureMaxSizeMb, initialContent = param.initialContent, initialEmbed = param.initialEmbed, _initialImages = param.initialImages, initialImages = _initialImages === void 0 ? [] : _initialImages, _isModify = param.isModify, isModify = _isModify === void 0 ? false : _isModify, className = param.className;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7;
    var editorRef = (0,react.useRef)(null);
    var ogPreview = (0,react.useRef)(false);
    var isCanSetOgPreview = (0,react.useRef)(!isModify);
    var forBlockDuplicateUrlAdded = (0,react.useRef)(false);
    var _$ref8 = (0,react.useState)(false), loading = _$ref8[0], setLoading = _$ref8[1];
    var _$ref9 = (0,react.useState)(initialImages), uploadedPictures = _$ref9[0], setUploadedPictures = _$ref9[1];
    var _$ref10 = (0,react.useState)(0), overflowLength = _$ref10[0], setOverflowLength = _$ref10[1];
    var _$ref11 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useNewsEditorLazyQuery */.C6B)(), 2), newsEditorQuery = _$ref11[0], _$ref12 = _$ref11[1], newsEditorData = _$ref12.data, newsEditorLoading = _$ref12.loading;
    var TOTAL_FILESIZE_LIMIT = pictureMaxSizeMb * 1000 * 1000;
    var handleResetOgPreview = function() {
        ogPreview.current = false;
        setLoading(null);
    };
    var handleSetOgPreview = function(ogResult) {
        var _$ref;
        if (isCanSetOgPreview.current && (!ogPreview.current || ((_$ref = ogPreview.current) === null || _$ref === void 0 ? void 0 : _$ref.error))) {
            ogPreview.current = ogResult;
        }
    };
    var _$ref13 = (0,_sliced_to_array/* default */.Z)((0,useDebouncedCallback/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(url, cb) {
            var data, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/api/ogs", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: new URLSearchParams({
                                    url: url
                                })
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        result = _state.sent();
                        cb(result);
                        return [
                            2
                        ];
                }
            });
        });
        return function(url, cb) {
            return _ref.apply(this, arguments);
        };
    }(), 300), 1), debounceFetchOgData = _$ref13[0];
    var handleUrlAdded = function(url) {
        var _$ref;
        if (isCanSetOgPreview.current && (!ogPreview.current || ((_$ref = ogPreview.current) === null || _$ref === void 0 ? void 0 : _$ref.error)) && !forBlockDuplicateUrlAdded.current) {
            setLoading(true);
            setTimeout(function() {
                setIsCanSubmit(false);
            }, 10) // 에디터 onChange에서 호출한 이후에 호출되도록 하기 위함
            ;
            forBlockDuplicateUrlAdded.current = true;
            debounceFetchOgData(url, function(result) {
                handleSetOgPreview(result);
                setLoading(false);
                setIsCanSubmit(true);
                forBlockDuplicateUrlAdded.current = false;
            });
        }
    };
    var handleFileInfo = function(files) {
        setUploadedPictures(files);
        isCanSetOgPreview.current = false;
    };
    var handleFilesDelete = function() {
        setUploadedPictures([]);
        isCanSetOgPreview.current = true;
    };
    var handleApplyTags = function(tags) {
        var _$ref, _$ref1;
        var lastIndexOfEditor = ((_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.quill) === null || _$ref1 === void 0 ? void 0 : _$ref1.getLength()) || 1;
        tags.map(function(tag) {
            var _$ref, _$ref1;
            return (_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.quill) === null || _$ref1 === void 0 ? void 0 : _$ref1.insertEmbed(lastIndexOfEditor, hashtag/* default.BLOT_NAME */.Z.BLOT_NAME, tag, "api");
        });
    };
    var parseOgPreviewData = function(ogPreview) {
        var ogImage;
        if (Array.isArray(ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogImage)) {
            var _$ref;
            ogImage = ogPreview === null || ogPreview === void 0 ? void 0 : (_$ref = ogPreview.ogImage) === null || _$ref === void 0 ? void 0 : _$ref[0];
        } else {
            ogImage = ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogImage;
        }
        return {
            imageUrl: ogImage === null || ogImage === void 0 ? void 0 : ogImage.url,
            domain: (0,util/* parseDomainFromUrl */.$1)((ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogUrl) || (ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.requestUrl) || ""),
            url: (ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogUrl) || (ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.requestUrl) || "",
            description: (ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogDescription) || (ogPreview === null || ogPreview === void 0 ? void 0 : ogPreview.ogTitle) || ""
        };
    };
    var handleGetValue = function() {
        var _$ref;
        return ((_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getValue()) || "";
    };
    (0,react.useImperativeHandle)(ref, function() {
        var _$ref;
        return {
            quill: (_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : _$ref.quill,
            getValue: handleGetValue,
            uploadedImageAttachmentIds: uploadedPictures.map(function(picture) {
                return picture.attachmentID;
            }),
            embedContent: ogPreview.current === false || ogPreview.current.error ? null : parseOgPreviewData(ogPreview.current.result)
        };
    });
    (0,react.useEffect)(function() {
        // TODO 더 깔끔하게 ref에 접근할 수 있는 방법으로 개선해보기
        setTimeout(function() {
            var _$ref, _$ref1;
            (_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.quill) === null || _$ref1 === void 0 ? void 0 : _$ref1.on("text-change", function(delta, oldDelta) {
                var textLength = getEditorLength(delta, oldDelta);
                if (textLength > 3000) {
                    setOverflowLength(textLength);
                } else {
                    setOverflowLength(0);
                }
                setIsCanSubmit(!loading && textLength >= 1 && textLength < 3001);
                setIsDirty && setIsDirty(true);
            });
        }, 500);
    }, [
        (_$ref = editorRef.current) === null || _$ref === void 0 ? void 0 : _$ref.quill,
        setIsCanSubmit,
        setIsDirty,
        setOverflowLength,
        loading, 
    ]);
    (0,react.useEffect)(function() {
        newsEditorQuery();
    }, [
        newsEditorQuery
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsEditor_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "scroll-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WriterInfo/* default */.Z, {
                        logoImageUrl: newsEditorData === null || newsEditorData === void 0 ? void 0 : (_$ref1 = newsEditorData.currentUser) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.channel) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.owner) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.logoImage) === null || _$ref4 === void 0 ? void 0 : _$ref4.url,
                        name: newsEditorData === null || newsEditorData === void 0 ? void 0 : (_$ref5 = newsEditorData.currentUser) === null || _$ref5 === void 0 ? void 0 : (_$ref6 = _$ref5.channel) === null || _$ref6 === void 0 ? void 0 : _$ref6.name,
                        isLoading: newsEditorLoading || !(newsEditorData === null || newsEditorData === void 0 ? void 0 : newsEditorData.currentUser),
                        className: "writer-info"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorWithForwardedRef, {
                        ref: editorRef,
                        onUrlAdded: handleUrlAdded,
                        placeholder: "사진, 텍스트, 태그 등을 이용해 새로운 소식을 알려주세요.\n팝업 하단의 ‘추천태그’를 선택하거나 샵(#)을 붙여 텍스트 입력 시\n이 태그에 관심있는 이용자에게 더 효율적으로 소식을 노출할 수 있습니다.\n(1자 이상 등록)\n          ",
                        initialValue: initialContent
                    }),
                    uploadedPictures.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "og-preview-wrapper",
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenGraphPreview_OpenGraphPreviewLoading, {}),
                            ogPreview.current !== false && !loading && (ogPreview.current.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenGraphPreview_OpenGraphPreviewError, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenGraphPreview_OpenGraphPreview, {
                                imageSrc: parseOgPreviewData(ogPreview.current.result).imageUrl,
                                domain: parseOgPreviewData(ogPreview.current.result).domain,
                                url: parseOgPreviewData(ogPreview.current.result).url,
                                description: parseOgPreviewData(ogPreview.current.result).description,
                                onClose: handleResetOgPreview
                            })),
                            initialEmbed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenGraphPreview_OpenGraphPreview, {
                                imageSrc: initialEmbed.imageUrl,
                                domain: initialEmbed.domain,
                                url: initialEmbed.url,
                                description: initialEmbed.description
                            })
                        ]
                    }),
                    uploadedPictures.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImageContentViewer, (0,_object_spread/* default */.Z)({
                        imageSrcList: uploadedPictures.map(function(picture) {
                            return picture.url;
                        })
                    }, !initialImages.length && {
                        onDelete: handleFilesDelete
                    }))
                ]
            }),
            overflowLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-helper-text",
                children: [
                    "최대 3000자까지 입력할 수 있습니다. (현재 ",
                    overflowLength,
                    "자)"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NewsEditorActions, {
                fileUploadDialogId: FILE_UPLOAD_ID,
                pictureButtonDisabled: isModify || uploadedPictures.length !== 0 || !(!ogPreview.current || ((_$ref7 = ogPreview.current) === null || _$ref7 === void 0 ? void 0 : _$ref7.error)) || !!loading,
                onApplyTags: handleApplyTags,
                className: "actions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUploadDialog/* default */.Z, {
                id: FILE_UPLOAD_ID,
                totalFileSizeLimit: TOTAL_FILESIZE_LIMIT,
                path: "/channel/news",
                getFileInfo: handleFileInfo,
                allowedFileTypes: constants_mimeTypes/* DOCUMENT_TO_MIME_TYPES */.cP[constants_mimeTypes/* DOCUMENT_TYPE.IMAGE */.tE.IMAGE],
                maxNumberOfFiles: 10
            })
        ]
    });
});
/* harmony default export */ var Editor_NewsEditor = (NewsEditor);
var NewsEditor_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsEditor__StyledWrapper",
    componentId: "sc-4f9fce8a-0"
})(NewsEditor_templateObject1());


/***/ }),

/***/ 14356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85025);
/* harmony import */ var _app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7029);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 450px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 0;\n\n  .title {\n    font-size: 24px;\n    font-weight: 600px;\n    line-height: 1.3;\n    text-align: center;\n  }\n  .close-btn {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n  .desc {\n    font-size: 16px;\n    font-weight: 400;\n  }\n  .button-box {\n    display: flex;\n    gap: 10px;\n    padding-top: 50px;\n    .button {\n      width: 88px;\n      height: 50px;\n      font-size: 16px;\n      color: #fff;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ConfirmCloseModal = function(param) {
    var onClose = param.onClose, onConfirm = param.onConfirm;
    var handleConfirm = function() {
        onConfirm();
        onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: true,
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "title",
                    children: [
                        "아직 저장되지 않은 ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "내용이 있습니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                            className: "close-btn",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desc",
                    children: "변경한 내용을 삭제하시겠어요?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "button-box",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "button",
                            color: "grey",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "button",
                            onClick: handleConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmCloseModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ConfirmCloseModal__StyledWrapper",
    componentId: "sc-f615d728-0"
})(_templateObject());


/***/ }),

/***/ 60125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96679);
/* harmony import */ var svgIcons_DefaultChannelLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46399);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  & .logo {\n    width: 44px;\n    height: 44px;\n    margin-right: 8px;\n    border: 1px solid #ddd;\n    object-fit: cover;\n    border-radius: 5px;\n  }\n\n  & .default-logo {\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: #eee;\n  }\n\n  & .name {\n    font-size: 18px;\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var WriterInfo = function(param) {
    var logoImageUrl = param.logoImageUrl, name = param.name, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className;
    if (isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            className: className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "logo"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    width: 80,
                    height: 20
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            logoImageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                src: logoImageUrl,
                alt: "writer logo",
                className: "logo"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_DefaultChannelLogo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "logo default-logo"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "name",
                children: name
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WriterInfo);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "WriterInfo__StyledWrapper",
    componentId: "sc-59be1f8c-0"
})(_templateObject());


/***/ }),

/***/ 41542:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BLOT_NAME: "hashtag",
    CLASS_NAME: "ql-hashtag",
    START_CHAR: "#"
});


/***/ }),

/***/ 96679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    background-color: rgba(0, 0, 0, 0.11);\n    border-radius: 4px;\n    animation: pulse 1.5s ease-in-out 0.5s infinite;\n\n    @keyframes pulse {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width, _height = param.height, height = _height === void 0 ? 16 : _height, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        width: width,
        height: height,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Skeleton__StyledWrapper",
    componentId: "sc-62e13890-0"
})(_templateObject1(), function(param) {
    var width = param.width, height = param.height;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), typeof width === "number" ? "".concat(width, "px") : width, typeof height === "number" ? "".concat(height, "px") : height);
});


/***/ }),

/***/ 83821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #01a0ff;\n  text-decoration: underline;\n  margin-right: 10px;\n\n  &:hover {\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SnackbarLink = function(param) {
    var href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            target: "_blank",
            rel: "noreferrer",
            children: "보러가기"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SnackbarLink);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "SnackbarLink__StyledWrapper",
    componentId: "sc-264aa138-0"
})(_templateObject());


/***/ }),

/***/ 67779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n\n  .radio-input + .radio-label {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n  }\n\n  input[type='radio'].radio-input {\n    display: none;\n  }\n\n  input[type='radio'].radio-input + .radio-label:before {\n    display: inline-block;\n    content: '';\n    width: 23px;\n    height: 23px;\n    border: 1px solid #cccccc;\n\n    border-radius: 50%;\n  }\n\n  input[type='radio'].radio-input + .radio-label:after {\n    position: absolute;\n    left: 0px;\n    font-size: 20px;\n    color: #ffffff;\n    width: 23px;\n    height: 23px;\n  }\n\n  input[type='radio'].radio-input + .radio-label:after {\n    opacity: 0;\n  }\n\n  input[type='radio']:checked.radio-input + .radio-label:after {\n    opacity: 1;\n    content: url('/static/images/channel/radio-active.svg');\n  }\n\n  & > .radio-label {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Radio = function(_param) {
    var labelText = _param.labelText, labelFor = _param.labelFor, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "labelText",
        "labelFor",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: "radio-input",
                type: "radio"
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                className: "radio-label",
                htmlFor: labelFor !== null && labelFor !== void 0 ? labelFor : "",
                children: labelText !== null && labelText !== void 0 ? labelText : ""
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Radio);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Radio__StyledWrapper",
    componentId: "sc-80a160d-0"
})(_templateObject());


/***/ }),

/***/ 26149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: visible;\n  .label {\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n  }\n  textarea {\n    font-family: inherit;\n    letter-spacing: inherit;\n    width: 100%;\n    height: 37px;\n    outline: none;\n    border: none;\n    flex-shrink: 1;\n    background-color: white;\n    border: 1px solid #e8e8e8;\n    padding: 8px;\n    border-radius: 5px;\n    resize: none;\n    &[data-error='true'] {\n      border: 1px solid #ef2929;\n    }\n  }\n  textarea[disabled] {\n    color: #999;\n    background-color: #eee;\n  }\n  .error {\n    font-size: 12px;\n    margin-top: 10px;\n    color: #ef2929;\n    width: 250px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Textarea = function(_param, ref) {
    var label = _param.label, className = _param.className, children = _param.children, _error = _param.error, error = _error === void 0 ? "" : _error, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "className",
        "children",
        "error"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref,
                rows: 5,
                autoComplete: "off",
                "data-error": !!error
            }, props)),
            children,
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "error",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(Textarea));
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Textarea__StyledWrapper",
    componentId: "sc-2c7e7f44-0"
})(_templateObject());


/***/ }),

/***/ 57628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BestStoryType; },
/* harmony export */   "r": function() { return /* binding */ ChannelUserType; }
/* harmony export */ });
var BestStoryType;
(function(BestStoryType) {
    BestStoryType["CHANNEL"] = "channel";
    BestStoryType["COMMUNITY"] = "community";
    BestStoryType["CBT_COMMUNITY"] = "cbtCommunity";
    BestStoryType["ALL"] = "all";
})(BestStoryType || (BestStoryType = {}));
var ChannelUserType;
(function(ChannelUserType) {
    ChannelUserType["NORMAL"] = "normal";
    ChannelUserType["CHANNEL"] = "channel";
    ChannelUserType["OWNER"] = "owner";
})(ChannelUserType || (ChannelUserType = {}));


/***/ }),

/***/ 33890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewsItemCommentForm_NewsItemCommentForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(57315);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/inputs/Textarea.tsx
var Textarea = __webpack_require__(26149);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useChannelError.ts
var useChannelError = __webpack_require__(65982);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/gql/updater/createNewsChildCommentUpdater.ts




var createNewsChildCommentUpdater = function(newsItemId, parentId) {
    return function(cache, mutationResult) {
        var variables = {
            newsItemId: newsItemId,
            parentId: parentId,
            commentFirst: 1,
            commentAfter: undefined
        };
        var cachedComments = cache.readQuery({
            query: graphql/* ChannelChildCommentsDocument */.AfH,
            variables: variables
        });
        if (!mutationResult.data || !mutationResult.data.createNewsComment.newsComment) return;
        var createdComment = {
            cursor: "",
            node: mutationResult.data.createNewsComment.newsComment,
            __typename: "NewsCommentEdge"
        };
        if (!cachedComments || !(cachedComments === null || cachedComments === void 0 ? void 0 : cachedComments.comments.edges)) return;
        cache.writeQuery({
            query: graphql/* ChannelChildCommentsDocument */.AfH,
            variables: variables,
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedComments), {
                comments: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedComments === null || cachedComments === void 0 ? void 0 : cachedComments.comments), {
                    edges: [
                        createdComment
                    ].concat((0,_to_consumable_array/* default */.Z)(cachedComments.comments.edges))
                })
            })
        });
        var targetFragmentOptions = {
            id: "NewsItem:".concat(newsItemId),
            fragment: graphql/* NewsItemFooter_NewsItemFragmentDoc */.jqE,
            fragmentName: "NewsItemFooter_NewsItem"
        };
        var cachedNewsItem = cache.readFragment((0,_object_spread/* default */.Z)({}, targetFragmentOptions));
        if (cachedNewsItem) {
            cache.writeFragment((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, targetFragmentOptions), {
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNewsItem), {
                    newsCommentCount: cachedNewsItem.newsCommentCount + 1
                })
            }));
        }
    };
};
/* harmony default export */ var updater_createNewsChildCommentUpdater = (createNewsChildCommentUpdater);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/gql/updater/createNewsCommentUpdater.ts



var createNewsCommentUpdater = function(newsItemId) {
    return function(cache, param) {
        var data = param.data;
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.createNewsComment) === null || ref === void 0 ? void 0 : ref.newsComment)) {
            return;
        }
        var targetFragmentOptions = {
            id: "NewsItem:".concat(newsItemId),
            fragment: graphql/* NewsItemFooter_NewsItemFragmentDoc */.jqE,
            fragmentName: "NewsItemFooter_NewsItem"
        };
        var cachedNewsItem = cache.readFragment((0,_object_spread/* default */.Z)({}, targetFragmentOptions));
        if (cachedNewsItem) {
            cache.writeFragment((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, targetFragmentOptions), {
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedNewsItem), {
                    newsCommentCount: cachedNewsItem.newsCommentCount + 1
                })
            }));
        }
    };
};
/* harmony default export */ var updater_createNewsCommentUpdater = (createNewsCommentUpdater);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentForm/NewsItemCommentForm.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  form {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    &[data-error='true'] {\n      padding-bottom: 18px;\n    }\n    .input-wrapper {\n      align-self: stretch;\n      position: relative;\n      width: 100%;\n      margin-left: 12px;\n      max-height: 84px;\n      .height {\n        padding: 9px;\n        font-size: 14px;\n        line-height: 22px;\n        word-break: break-word;\n        /* overflow 방지 */\n        max-height: 84px;\n        overflow: scroll;\n      }\n      .comment-input {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        textarea {\n          height: 100%;\n          font-size: 14px;\n          line-height: 22px;\n        }\n        .error {\n          bottom: 0;\n          transform: translateY(100%);\n          position: absolute;\n          padding-top: 8px;\n          color: #ef2929;\n        }\n      }\n    }\n    .btn-wrapper {\n      align-self: stretch;\n      flex-shrink: 0;\n      .btn {\n        min-height: 40px;\n        height: 100%;\n        margin-left: 4px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var NewsItemCommentForm = function(param, ref) {
    var newsItemId = param.newsItemId, parentId = param.parentId, viewerCanReply = param.viewerCanReply, className = param.className, _expendComment = param.expendComment, expendComment = _expendComment === void 0 ? false : _expendComment, _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function() {} : _onSuccess;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var data = (0,graphql/* useCurrentUserQuery */.rkO)().data;
    var _$ref6 = (0,react.useState)(false), loginModalOpened = _$ref6[0], setLoginModalOpened = _$ref6[1];
    var onError = (0,useChannelError/* default */.Z)();
    var _$ref7 = (0,react.useState)(""), input = _$ref7[0], setInput = _$ref7[1];
    var _$ref8 = (0,react.useState)(""), error = _$ref8[0], setError = _$ref8[1];
    var createNewsCommentMutation = (0,graphql/* useGqlCreateNewsCommentMutation */.A2E)({
        onCompleted: function() {
            onSuccess();
        },
        onError: onError
    });
    var handleSubmit = function(event) {
        event.preventDefault();
        var content = input.trim();
        if (content === "") return;
        var _createNewsCommentMutation = (0,_sliced_to_array/* default */.Z)(createNewsCommentMutation, 1), createNewsComment = _createNewsCommentMutation[0];
        if (parentId) {
            var variables = {
                input: {
                    content: content,
                    newsItemId: newsItemId,
                    parentId: parentId
                }
            };
            createNewsComment({
                variables: variables,
                update: updater_createNewsChildCommentUpdater(newsItemId, parentId)
            });
        } else {
            var variables1 = {
                input: {
                    content: input,
                    newsItemId: newsItemId
                }
            };
            createNewsComment({
                variables: variables1,
                refetchQueries: [
                    {
                        query: graphql/* GqlNewsItemCommentListDocument */.O28,
                        variables: {
                            newsItemId: newsItemId,
                            commentFirst: isMobile || expendComment ? 10 : 5,
                            commentAfter: null
                        }
                    }, 
                ],
                update: updater_createNewsCommentUpdater(newsItemId)
            });
        }
        setInput("");
    };
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (value.length > 1000) setError("최대 1000자까지 입력할 수 있습니다.(현재 ".concat(value.length, "자)"));
        else setError("");
        setInput(value);
    };
    var avatarType = (data === null || data === void 0 ? void 0 : (_$ref = data.currentUser) === null || _$ref === void 0 ? void 0 : _$ref.channel) ? "channel" : "user";
    var avatarSrc = avatarType === "user" ? data === null || data === void 0 ? void 0 : (_$ref1 = data.currentUser) === null || _$ref1 === void 0 ? void 0 : _$ref1.avatarUrl : data === null || data === void 0 ? void 0 : (_$ref2 = data.currentUser) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.channel) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.owner) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.logoImage) === null || _$ref5 === void 0 ? void 0 : _$ref5.url;
    var handleClick = function() {
        if (onError()) return;
        if (!viewerCanReply) {
            setLoginModalOpened(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
                className: className,
                onClick: handleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    "data-error": !!error,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: 40,
                            type: avatarType,
                            src: avatarSrc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "input-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "height",
                                    children: (0,util/* convertStringToContent */.Hw)(input)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, {
                                    placeholder: viewerCanReply ? "댓글을 입력하세요." : "로그인 후 댓글을 작성할 수 있습니다.",
                                    autoComplete: "off",
                                    spellCheck: false,
                                    className: "comment-input",
                                    name: "input",
                                    value: input,
                                    error: error,
                                    onChange: handleChangeInput,
                                    disabled: !viewerCanReply,
                                    ref: ref
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "btn-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "btn",
                                type: "submit",
                                disabled: input.trim() === "" || !viewerCanReply || !!error,
                                children: "등록"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpened
                },
                onRequestClose: function() {
                    return setLoginModalOpened(false);
                }
            })
        ]
    });
};
/* harmony default export */ var NewsItemCommentForm_NewsItemCommentForm = (/*#__PURE__*/(0,react.forwardRef)(NewsItemCommentForm));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemCommentForm__StyledWrapper",
    componentId: "sc-99fafc1d-0"
})(_templateObject());


/***/ }),

/***/ 69431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ component_NewsItemCommentList; }
});

// UNUSED EXPORTS: DEFAULT_COMMENT_FIRST, EXPANDED_COMMENT_FIRST

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(7145);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/components/BounceLoading.tsx
var BounceLoading = __webpack_require__(14609);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/svgIcons/NewsMoreComment.tsx

function NewsMoreComment() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        "aria-label": "소식 댓글 더보기",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "소식 댓글 더보기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "uetzawpmza",
                    width: "50",
                    height: "50",
                    x: "0",
                    y: "0",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0.161"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "data-name": "그룹 11032",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#uetzawpmza)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            fill: "#fff",
                            stroke: "#999",
                            "data-name": "타원 1043",
                            transform: "translate(9 7)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "16",
                                    r: "16",
                                    stroke: "none"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "16",
                                    cy: "16",
                                    r: "15.5",
                                    fill: "none"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#999",
                        stroke: "#999",
                        strokeLinecap: "round",
                        strokeWidth: "1.5",
                        "data-name": "사각형 8732",
                        transform: "rotate(90 4.968 20.968)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "14",
                                height: "1.5",
                                stroke: "none",
                                rx: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "12.5",
                                x: "0.75",
                                y: "0.75",
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#999",
                        stroke: "#999",
                        strokeLinecap: "round",
                        strokeWidth: "1.5",
                        "data-name": "사각형 8733",
                        transform: "rotate(180 16 11.875)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "14",
                                height: "1.5",
                                stroke: "none",
                                rx: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "12.5",
                                x: "0.75",
                                y: "0.75",
                                fill: "none"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var svgIcons_NewsMoreComment = (NewsMoreComment);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/inputs/Textarea.tsx
var Textarea = __webpack_require__(26149);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useExpendBtn.tsx
var useExpendBtn = __webpack_require__(14653);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.modules/util/time.tsx
var time = __webpack_require__(20178);
// EXTERNAL MODULE: ./src/app.components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(57315);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentForm/NewsItemCommentForm.tsx + 2 modules
var NewsItemCommentForm = __webpack_require__(33890);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 2 modules
var notistack_esm = __webpack_require__(29496);
// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/AlreadyReportedModal.tsx
var AlreadyReportedModal = __webpack_require__(79127);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useChannelError.ts
var useChannelError = __webpack_require__(65982);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/BanUserModal.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 620px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px 0;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n    padding: 0 30px;\n  }\n  .modal-title {\n    width: 100%;\n    font-size: 24px;\n    font-weight: 500;\n    padding-bottom: 30px;\n    text-align: center;\n    border-bottom: 1px solid #eeeeee;\n  }\n  .modal-description {\n    font-size: 16px;\n    margin: 40px 0 30px;\n    padding: 0 60px;\n    width: 100%;\n    p {\n      margin-bottom: 12px;\n    }\n    li {\n      position: relative;\n      margin-bottom: 5px;\n    }\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var BanUserModal = function(_param) {
    var onClose = _param.onClose, data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose",
        "data"
    ]);
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var muteUserMutation = (0,graphql/* useGqlMuteUserMutation */.KM5)({
        // update: muteUserUpdater(data.node.id),
        onCompleted: function() {
            enqueueSnackbar("회원이 차단되었습니다.");
        },
        onError: onError
    });
    var fetchMuteUser = function() {
        if (!data.node.author) return;
        var _muteUserMutation = (0,_sliced_to_array/* default */.Z)(muteUserMutation, 1), mutate = _muteUserMutation[0];
        mutate({
            variables: {
                input: {
                    mutedUserId: data.node.author.id,
                    newsCommentId: data.node.id
                }
            }
        });
    };
    var onConfirm = function() {
        fetchMuteUser();
        onClose && onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            className: "common-modal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-title",
                    children: "이 회원을 차단하시겠어요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-description",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "회원 차단 시 아래와 같이 조치됩니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "채널 메뉴 내 모든 화면에서 이 회원의 댓글이 회원님에게 보이지 않습니다."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "차단한 회원을 다시 보려면 차단된 회원 댓글의 [더보기] 버튼을 선택하여 차단해제 해주세요."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn",
                            onClick: onConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var modals_BanUserModal = (BanUserModal);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BanUserModal__StyledWrapper",
    componentId: "sc-2d58d943-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/DeleteCommentModal.tsx





function DeleteCommentModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 360px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-sub-title {\n    font-size: 20px;\n    margin: 20px 0 31px;\n    width: 100%;\n    text-align: center;\n    font-weight: 500;\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    DeleteCommentModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var DeleteCommentModal = function(_param) {
    var id = _param.id, onClose = _param.onClose, onCompleted = _param.onCompleted, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "onClose",
        "onCompleted"
    ]);
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var deleteNewsCommentMutation = (0,graphql/* useDeleteNewsCommentMutation */.UeX)({
        onCompleted: function() {
            onCompleted();
            enqueueSnackbar("댓글이 삭제되었습니다.");
        },
        onError: onError
    });
    var handleConfirm = function() {
        var _deleteNewsCommentMutation = (0,_sliced_to_array/* default */.Z)(deleteNewsCommentMutation, 1), mutate = _deleteNewsCommentMutation[0];
        mutate({
            variables: {
                newsCommentId: id
            }
        });
        onClose && onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteCommentModal_StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-sub-title",
                    children: "댓글을 삭제하시겠어요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn",
                            onClick: handleConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var modals_DeleteCommentModal = (DeleteCommentModal);
var DeleteCommentModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeleteCommentModal__StyledWrapper",
    componentId: "sc-7d01faf0-0"
})(DeleteCommentModal_templateObject(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/ReportModal.tsx
var ReportModal = __webpack_require__(44575);
// EXTERNAL MODULE: ./src/app.modules/hooks/useDropdown.tsx
var useDropdown = __webpack_require__(6714);
// EXTERNAL MODULE: ./src/app.feature/channel/component/MoreDropdownBtn.tsx
var MoreDropdownBtn = __webpack_require__(61996);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/DropdownBtn/DropdownBtn.tsx


function DropdownBtn_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  .more-menu-btn {\n    width: 28px;\n    height: 28px;\n    .dot {\n      width: 3.5px;\n      height: 3.5px;\n    }\n  }\n  .more-menu-list {\n    z-index: 1;\n    display: none;\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    border: 1px solid #cccccc;\n    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16);\n    border-radius: 5px;\n    padding: 6px 0;\n    text-align: center;\n    white-space: nowrap;\n    font-size: 12px;\n    background-color: white;\n    .more-menu {\n      display: block;\n      border: none;\n      background: none;\n      padding: 4px 12px;\n      &:hover {\n        background-color: #f8f8f8;\n      }\n    }\n    &[data-open='true'] {\n      display: block;\n    }\n  }\n"
    ]);
    DropdownBtn_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var DropdownBtn = function(param) {
    var data = param.data, onEditMenuClick = param.onEditMenuClick, onDeleteMenuClick = param.onDeleteMenuClick;
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDropdown/* default */.Z)(), 3), menuRef = ref[0], isDropdownOpened = ref[1], handleDropDownBtn = ref[2];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var ref1 = (0,react.useState)(false), reportModalopen = ref1[0], setReportModalopen = ref1[1];
    var ref2 = (0,react.useState)(false), deleteModalopen = ref2[0], setDeleteModalOpen = ref2[1];
    var ref3 = (0,react.useState)(false), banModalopen = ref3[0], setBanModalOpen = ref3[1];
    var ref4 = (0,react.useState)(false), loginModalOpened = ref4[0], setLoginModalOpened = ref4[1];
    var unMuteUserMutation = (0,graphql/* useGqlUnMuteUserMutation */.rNB)({
        // update: unMuteUserUpdater(data.node.id),
        onCompleted: function() {
            enqueueSnackbar("차단이 해제되었습니다.");
        },
        onError: onError
    });
    var fetchUnMuteUser = function() {
        if (onError()) return;
        if (!data.node.author) return;
        var _unMuteUserMutation = (0,_sliced_to_array/* default */.Z)(unMuteUserMutation, 1), mutate = _unMuteUserMutation[0];
        mutate({
            variables: {
                input: {
                    mutedUserId: data.node.author.id,
                    newsCommentId: data.node.id
                }
            }
        });
    };
    var menus = (0,react.useMemo)(function() {
        var ref;
        var menus = [];
        // 신고
        if (!data.node.viewerIsAuthor) {
            menus.push({
                label: "댓글 신고",
                handleClick: function() {
                    var ref;
                    if (onError()) return;
                    if (!((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) return setLoginModalOpened(true);
                    setReportModalopen(true);
                }
            });
        }
        // 차단 해제
        if (!data.node.viewerIsAuthor && ((ref = data.node.author) === null || ref === void 0 ? void 0 : ref.__typename) === "User") {
            if (data.node.viewerHasMuteAuthor) {
                menus.push({
                    label: "회원 차단 해제",
                    handleClick: fetchUnMuteUser
                });
            } else {
                menus.push({
                    label: "회원 차단",
                    handleClick: function() {
                        if (onError()) return;
                        setBanModalOpen(true);
                    }
                });
            }
        }
        // 수정
        if (data.node.viewerIsAuthor) {
            menus.push({
                label: "댓글 수정",
                handleClick: function() {
                    if (onError()) return;
                    onEditMenuClick();
                }
            });
        }
        // 삭제
        if (data.node.viewerCanDelete) {
            menus.push({
                label: "댓글 삭제",
                handleClick: function() {
                    if (onError()) return;
                    setDeleteModalOpen(true);
                }
            });
        }
        return menus;
    }, [
        data,
        currentUserQuery.data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownBtn_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: menuRef,
                onClick: handleDropDownBtn,
                "data-open": isDropdownOpened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreDropdownBtn/* default */.Z, {
                    className: "more-menu-btn"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "more-menu-list",
                "data-open": isDropdownOpened,
                children: menus.map(function(menu, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "more-menu",
                        onClick: menu.handleClick,
                        children: menu.label
                    }, idx);
                })
            }),
            data.node.viewerHasReported && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlreadyReportedModal/* default */.Z, {
                type: "comment",
                open: reportModalopen,
                onClose: function() {
                    return setReportModalopen(false);
                }
            }),
            !data.node.viewerHasReported && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal/* default */.Z, {
                type: "comment",
                open: reportModalopen,
                reportedId: data.node.id,
                onClose: function() {
                    return setReportModalopen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_BanUserModal, {
                open: banModalopen,
                data: data,
                onClose: function() {
                    return setBanModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_DeleteCommentModal, {
                open: deleteModalopen,
                id: data.node.id,
                onClose: function() {
                    return setDeleteModalOpen(false);
                },
                onCompleted: onDeleteMenuClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpened
                },
                onRequestClose: function() {
                    return setLoginModalOpened(false);
                }
            })
        ]
    });
};
/* harmony default export */ var DropdownBtn_DropdownBtn = (DropdownBtn);
var DropdownBtn_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropdownBtn__StyledWrapper",
    componentId: "sc-41a964aa-0"
})(DropdownBtn_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/DropdownBtn/index.tsx

/* harmony default export */ var NewsItemComment_DropdownBtn = (DropdownBtn_DropdownBtn);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/SubCommentList/SubCommentList.module.tsx

var getLastCursor = function(edges) {
    if (!edges || edges.length === 0) return undefined;
    return edges[edges.length - 1] ? edges[edges.length - 1].cursor || undefined : undefined;
};
var ChannelChildCommentsUpdateQuery = function(previousQueryResult, param) {
    var fetchMoreResult = param.fetchMoreResult;
    if (!fetchMoreResult) return previousQueryResult;
    return immutability_helper_default()(previousQueryResult, {
        comments: {
            edges: {
                $push: fetchMoreResult.comments.edges
            },
            pageInfo: {
                $set: fetchMoreResult.comments.pageInfo
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/SubCommentList/SubCommentList.tsx




function SubCommentList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query channelChildComments(\n    $newsItemId: ID!\n    $parentId: ID!\n    $commentFirst: Int!\n    $commentAfter: String\n  ) {\n    comments(\n      newsItemId: $newsItemId\n      parentId: $parentId\n      first: $commentFirst\n      after: $commentAfter\n    ) {\n      totalCount\n      edges {\n        ...NewsItemComment_NewsCommentEdge\n      }\n      pageInfo {\n        hasNextPage\n      }\n    }\n  }\n"
    ]);
    SubCommentList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .sub-comment-more-btn {\n        margin-left: 44px;\n      }\n      .sub-comment-list {\n        margin-left: 44px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .sub-comment-more-btn {\n    display: block;\n    margin-left: 52px;\n    padding-bottom: 16px;\n    font-size: 12px;\n    color: #555555;\n  }\n  .sub-comment-list {\n    margin-left: 52px;\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








src_default()(SubCommentList_templateObject());
var SubCommentList = function(param) {
    var _type = param.type, type = _type === void 0 ? "card" : _type, newsItemId = param.newsItemId, viewerIsNewsAuthor = param.viewerIsNewsAuthor, parentId = param.parentId;
    var initialVariables = {
        newsItemId: newsItemId,
        parentId: parentId,
        commentFirst: 1,
        commentAfter: undefined
    };
    // 대댓글 더 불러오기
    var ref = (0,graphql/* useChannelChildCommentsQuery */.mJv)({
        variables: initialVariables
    }), data = ref.data, fetchMore = ref.fetchMore;
    var cursor = getLastCursor(data === null || data === void 0 ? void 0 : data.comments.edges);
    var handleMoreBtn = function() {
        if (!data) return;
        var variables = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialVariables), {
            commentFirst: 10,
            commentAfter: cursor
        });
        fetchMore({
            variables: variables,
            updateQuery: ChannelChildCommentsUpdateQuery
        });
    };
    var hasMoreSubComment = (0,react.useMemo)(function() {
        if (data) return data.comments.pageInfo.hasNextPage;
        return false;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCommentList_StyledWrapper, {
        type: type,
        children: [
            hasMoreSubComment && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "sub-comment-more-btn",
                onClick: handleMoreBtn,
                children: "―― 이전 답글 보기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sub-comment-list",
                children: data && (0,_to_consumable_array/* default */.Z)(data.comments.edges).reverse().map(function(comment) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentList_NewsItemComment, {
                        newsItemId: newsItemId,
                        viewerIsNewsAuthor: viewerIsNewsAuthor,
                        isRootComment: false,
                        data: comment
                    }, comment.node.id);
                })
            })
        ]
    });
};
/* harmony default export */ var SubCommentList_SubCommentList = (SubCommentList);
var SubCommentList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SubCommentList__StyledWrapper",
    componentId: "sc-50f137de-0"
})(_templateObject2(), function(param) {
    var type = param.type;
    return type === "modal" && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/SubCommentList/index.tsx

/* harmony default export */ var NewsItemComment_SubCommentList = (SubCommentList_SubCommentList);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/index.styled.tsx

function index_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .user-profile {\n        .lt {\n          gap: 8px;\n          .content {\n            .user-name {\n              font-size: 14px;\n              padding-bottom: 0;\n            }\n          }\n        }\n      }\n      .description {\n        margin-left: 44px;\n      }\n      .tool-box {\n        margin-left: 44px;\n      }\n    "
    ]);
    index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .reply-btn {\n    font-size: 12px;\n    padding: 0px;\n    background: none;\n    border: none;\n  }\n  .comment-view {\n    .user-profile {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 12px;\n      .lt {\n        display: flex;\n        margin-right: 4px;\n        gap: 12px;\n        overflow: hidden;\n        .content {\n          overflow: hidden;\n          .top {\n            gap: 4px;\n            width: 100%;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            .user-name {\n              display: block;\n              font-size: 16px;\n              font-weight: bold;\n              padding-bottom: 2px;\n\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n            }\n            .news-author {\n              border: 1px solid #01a0ff;\n              border-radius: 3px;\n              color: #01a0ff;\n              font-size: 10px;\n              padding: 3px 5px;\n              font-weight: 700;\n              flex-shrink: 0;\n            }\n          }\n          .user-info {\n            font-size: 12px;\n            color: #9f9f9f;\n            display: flex;\n            gap: 8px;\n          }\n        }\n      }\n    }\n    .description {\n      margin-left: 52px;\n      background-color: #fafafa;\n      padding: 12px 15px;\n      border-radius: 5px;\n      font-size: 14px;\n      margin-bottom: 8px;\n\n      .desc-content {\n        margin-bottom: 4px;\n        line-height: 22px;\n        max-height: 66px;\n        overflow: hidden;\n        overflow-wrap: anywhere;\n        &[data-expend='true'] {\n          max-height: fit-content;\n        }\n      }\n      .desc-more-btn {\n        color: #777777;\n      }\n    }\n  }\n  .comment-edit {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 8px;\n    .rt {\n      position: relative;\n      width: 100%;\n      align-self: stretch;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 8px;\n      .edit-input {\n        width: 100%;\n        height: 40px;\n      }\n      .input-wrapper {\n        position: relative;\n        width: 100%;\n        margin-left: 12px;\n        padding: 10px;\n        width: 100%;\n        min-height: 36px;\n        font-size: 12px;\n        line-height: 16px;\n        .comment-input {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          textarea {\n            height: 100%;\n            font-size: 12px;\n            line-height: 16px;\n          }\n        }\n      }\n      .btn-box {\n        display: flex;\n        gap: 4px;\n      }\n    }\n  }\n\n  .comment-delete {\n    padding-bottom: 16px;\n  }\n\n  .comment-mute {\n    padding-top: 4px;\n    padding-bottom: 16px;\n  }\n\n  .tool-box {\n    margin-left: 52px;\n    font-size: 12px;\n    color: #555;\n    display: flex;\n    gap: 8px;\n    padding-bottom: 16px;\n  }\n\n  .comment-form {\n    padding-left: 52px;\n  }\n  ",
        "\n"
    ]);
    index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var index_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "index.styled__StyledWrapper",
    componentId: "sc-d27b2d1f-0"
})(index_styled_templateObject1(), function(param) {
    var type = param.type;
    return type === "modal" && (0,styled_components_browser_esm/* css */.iv)(index_styled_templateObject());
});
/* harmony default export */ var index_styled = (index_styled_StyledWrapper);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/NewsItemComment/index.tsx


function NewsItemComment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemComment_NewsCommentEdge on NewsCommentEdge {\n    node {\n      ...NewsComment_NewsComment\n    }\n    cursor\n  }\n\n  fragment NewsComment_NewsComment on NewsComment {\n    id\n    authorName\n    content\n    createdAt\n    updatedAt\n    deletedAt\n    viewerCanReply\n    viewerCanDelete\n    viewerIsAuthor\n    viewerHasReported\n    viewerHasMuteAuthor\n    author {\n      ... on Channel {\n        id\n        url\n        viewerIsOwner\n        owner {\n          id\n          logoImage {\n            id\n            url\n          }\n        }\n      }\n      ... on User {\n        id\n        avatarUrl\n      }\n    }\n    newsItem {\n      id\n      channel {\n        id\n      }\n    }\n    children {\n      totalCount\n    }\n  }\n"
    ]);
    NewsItemComment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















src_default()(NewsItemComment_templateObject());
var NewsItemComment = function(param) {
    var _type = param.type, type = _type === void 0 ? "card" : _type, newsItemId = param.newsItemId, viewerIsNewsAuthor = param.viewerIsNewsAuthor, data = param.data, _isRootComment = param.isRootComment, isRootComment = _isRootComment === void 0 ? true : _isRootComment;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var ref8 = (0,react.useState)(false), replyOpen = ref8[0], setReplyOpen = ref8[1];
    var getCommentType = function() {
        if (data.node.deletedAt) return "DELETE";
        if (data.node.viewerHasMuteAuthor) return "MUTE";
        return "VIEW";
    };
    var ref9 = (0,react.useState)(getCommentType()), commentType = ref9[0], setCommentType = ref9[1];
    var ref10 = (0,react.useState)(""), input = ref10[0], setInput = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useExpendBtn/* default */.Z)(), 3), isExpended = ref11[0], descriptionRef = ref11[1], handleExpendBtnClick = ref11[2];
    var updateNewsCommentMutation = (0,graphql/* useUpdateNewsCommentMutation */.sqo)();
    (0,react.useEffect)(function() {
        setCommentType(getCommentType());
    }, [
        data
    ]);
    var handleCancleUpdateBtn = function() {
        setCommentType("VIEW");
        setInput("");
    };
    var handleUpdateCommentBtn = function() {
        if (input === data.node.content) return handleCancleUpdateBtn();
        var _updateNewsCommentMutation = (0,_sliced_to_array/* default */.Z)(updateNewsCommentMutation, 1), mutate = _updateNewsCommentMutation[0];
        mutate({
            variables: {
                input: {
                    id: data.node.id,
                    content: input
                }
            }
        });
        handleCancleUpdateBtn();
    };
    var handleEditMenuClick = function() {
        setCommentType("EDIT");
        setInput(data.node.content);
    };
    var handleDeleteMenuClick = function() {
        setReplyOpen(false);
    };
    var imageUrl = (0,react.useMemo)(function() {
        var ref, ref1;
        var result = "";
        if (((ref = data.node.author) === null || ref === void 0 ? void 0 : ref.__typename) === "Channel") {
            var ref2, ref3;
            result = ((ref2 = data.node.author.owner) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.logoImage) === null || ref3 === void 0 ? void 0 : ref3.url) || "";
        }
        if (((ref1 = data.node.author) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "User") {
            result = data.node.author.avatarUrl || "";
        }
        return result;
    }, [
        data
    ]);
    var channelHref = ((ref = data.node.author) === null || ref === void 0 ? void 0 : ref.__typename) === "Channel" ? (0,util/* getWebviewHref */.ys)("/channel/".concat(data.node.author.url), isWebview) : undefined;
    var isNewsAuthor = (data === null || data === void 0 ? void 0 : (ref1 = data.node) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.newsItem) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.channel) === null || ref3 === void 0 ? void 0 : ref3.id) === (data === null || data === void 0 ? void 0 : (ref4 = data.node) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.author) === null || ref5 === void 0 ? void 0 : ref5.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled, {
        type: type,
        children: [
            commentType === "VIEW" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "comment-view",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "user-profile",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lt",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        type: ((ref6 = data.node.author) === null || ref6 === void 0 ? void 0 : ref6.__typename) === "Channel" ? "channel" : "user",
                                        size: type === "card" ? 40 : 36,
                                        href: channelHref,
                                        src: imageUrl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content",
                                        children: [
                                            channelHref && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: channelHref,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "top",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "user-name",
                                                                children: data.node.authorName
                                                            }),
                                                            isNewsAuthor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "news-author",
                                                                children: "담당자"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            !channelHref && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "top",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "user-name",
                                                        children: data.node.authorName
                                                    }),
                                                    isNewsAuthor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "news-author",
                                                        children: "담당자"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "user-info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "date",
                                                        children: (0,time/* convertCreatedAtToString */.Ui)(data.node.createdAt)
                                                    }),
                                                    data.node.updatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "(수정됨)"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemComment_DropdownBtn, {
                                data: data,
                                onEditMenuClick: handleEditMenuClick,
                                onDeleteMenuClick: handleDeleteMenuClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc-content",
                                "data-expend": isExpended,
                                ref: descriptionRef,
                                children: (0,util/* convertStringToContent */.Hw)(data.node.content)
                            }),
                            isExpended === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "desc-more-btn",
                                onClick: handleExpendBtnClick,
                                children: "...더보기"
                            })
                        ]
                    })
                ]
            }),
            commentType === "DELETE" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "comment-delete",
                children: (0,util/* convertStringToContent */.Hw)(data.node.content)
            }),
            commentType === "MUTE" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "comment-view",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "user-profile",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "comment-mute",
                            children: (0,util/* convertStringToContent */.Hw)(data.node.content)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemComment_DropdownBtn, {
                            data: data,
                            onEditMenuClick: handleEditMenuClick,
                            onDeleteMenuClick: handleDeleteMenuClick
                        })
                    ]
                })
            }),
            commentType === "EDIT" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "comment-edit",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        type: ((ref7 = data.node.author) === null || ref7 === void 0 ? void 0 : ref7.__typename) === "Channel" ? "channel" : "user",
                        size: type === "card" ? 40 : 36,
                        href: channelHref,
                        src: imageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rt",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "input-wrapper",
                                children: [
                                    (0,util/* convertStringToContent */.Hw)(input),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, {
                                        placeholder: "댓글을 입력하세요.",
                                        autoComplete: "off",
                                        spellCheck: false,
                                        className: "comment-input",
                                        name: "input",
                                        value: input,
                                        onChange: function(event) {
                                            return setInput(event.target.value);
                                        },
                                        maxLength: 1000
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "btn-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "grey",
                                        variant: "outlined",
                                        onClick: handleCancleUpdateBtn,
                                        children: "취소"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: handleUpdateCommentBtn,
                                        disabled: input.trim() === "",
                                        children: "적용"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isRootComment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    commentType === "VIEW" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tool-box",
                        children: [
                            data.node.viewerCanReply === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "reply-btn",
                                onClick: function() {
                                    return setReplyOpen(!replyOpen);
                                },
                                children: replyOpen ? "취소" : "답글쓰기"
                            }),
                            data.node.children.totalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "reply-count",
                                children: [
                                    "답글 ",
                                    data.node.children.totalCount
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemComment_SubCommentList, {
                        type: type,
                        newsItemId: newsItemId,
                        viewerIsNewsAuthor: viewerIsNewsAuthor,
                        parentId: data.node.id
                    }),
                    replyOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentForm/* default */.Z, {
                        className: "comment-form",
                        newsItemId: newsItemId,
                        parentId: data.node.id,
                        onSuccess: function() {
                            return setReplyOpen(false);
                        },
                        viewerCanReply: data.node.viewerCanReply
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NewsItemCommentList_NewsItemComment = (NewsItemComment);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/index.tsx

function NewsItemCommentList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlNewsItemCommentList(\n    $newsItemId: ID!\n    $commentFirst: Int!\n    $commentAfter: String\n  ) {\n    comments(\n      first: $commentFirst\n      after: $commentAfter\n      newsItemId: $newsItemId\n    ) {\n      edges {\n        ...NewsItemComment_NewsCommentEdge\n      }\n      pageInfo {\n        hasNextPage\n      }\n    }\n  }\n"
    ]);
    NewsItemCommentList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsItemCommentList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .hr {\n    height: 1px;\n    background-color: #e8e8e8;\n    margin-bottom: 20px;\n  }\n  .comment-list {\n    padding: 0 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n    margin-bottom: 20px;\n  }\n  .more-btn {\n    display: flex;\n    font-size: 14px;\n    font-weight: 500;\n    justify-content: center;\n    padding-bottom: 24px;\n    gap: 7px;\n    .expand-more-icon {\n      width: 13px;\n    }\n  }\n  .modal-more-btn {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    margin: 0 20px;\n    svg {\n      z-index: 1;\n    }\n    &::before {\n      content: '';\n      height: 1px;\n      width: 100%;\n      top: 50%;\n      transform: translate(0, -3px);\n      position: absolute;\n      background-color: #eeeeee;\n    }\n  }\n  .empty-comment {\n    display: flex;\n    flex-direction: column;\n    color: #777;\n    align-items: center;\n    padding: 180px 0;\n    .empty-comment-title {\n      font-size: 15px;\n    }\n    .empty-comment-desc {\n      font-size: 12px;\n    }\n  }\n  .loading-wrapper {\n    display: flex;\n    justify-content: center;\n    padding: 30px;\n    .loading {\n      width: fit-content;\n      & > div {\n        width: 8px;\n        height: 8px;\n      }\n    }\n  }\n"
    ]);
    NewsItemCommentList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(NewsItemCommentList_templateObject());
// todo first 개수 props로 넘겨줘야함.
var DEFAULT_COMMENT_FIRST = 5;
var EXPANDED_COMMENT_FIRST = 10;
var NewsItemCommentList = function(param) {
    var _type = param.type, type = _type === void 0 ? "card" : _type, newsItemId = param.newsItemId, viewerIsAuthor = param.viewerIsAuthor, _expendComment = param.expendComment, expendComment = _expendComment === void 0 ? false : _expendComment;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,graphql/* useGqlNewsItemCommentListQuery */.VhH)({
        variables: {
            newsItemId: newsItemId,
            commentFirst: isMobile || expendComment ? EXPANDED_COMMENT_FIRST : DEFAULT_COMMENT_FIRST,
            commentAfter: null
        }
    }), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore;
    var handleMoreBtnClick = function() {
        if (!data) return;
        var moreCommentsEdges = data.comments.edges;
        var cursor = moreCommentsEdges[moreCommentsEdges.length - 1].cursor;
        var variables = {
            newsItemId: newsItemId,
            commentFirst: EXPANDED_COMMENT_FIRST,
            commentAfter: cursor
        };
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult) return previousQueryResult;
                return immutability_helper_default()(previousQueryResult, {
                    comments: {
                        edges: {
                            $push: fetchMoreResult.comments.edges
                        },
                        pageInfo: {
                            $set: fetchMoreResult.comments.pageInfo
                        }
                    }
                });
            }
        });
    };
    var hasMoreComment = (0,react.useMemo)(function() {
        if (!data) return false;
        return data.comments.pageInfo.hasNextPage;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItemCommentList_StyledWrapper, {
        children: [
            data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    data.comments.edges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            type === "card" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hr"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "comment-list",
                                children: data.comments.edges.map(function(comment) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentList_NewsItemComment, {
                                        type: type,
                                        newsItemId: newsItemId,
                                        viewerIsNewsAuthor: viewerIsAuthor,
                                        data: comment
                                    }, comment.cursor);
                                })
                            })
                        ]
                    }),
                    data.comments.edges.length === 0 && type === "modal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "empty-comment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "empty-comment-title",
                                children: "아직 댓글이 없습니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "empty-comment-desc",
                                children: "가장 먼저 댓글을 남겨보세요."
                            })
                        ]
                    })
                ]
            }),
            hasMoreComment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    type === "card" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "more-btn",
                        onClick: handleMoreBtnClick,
                        children: [
                            "댓글 더보기",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                className: "expand-more-icon"
                            })
                        ]
                    }),
                    type === "modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "modal-more-btn",
                        onClick: handleMoreBtnClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_NewsMoreComment, {})
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BounceLoading/* default */.Z, {
                    className: "loading"
                })
            })
        ]
    });
};
/* harmony default export */ var component_NewsItemCommentList = (NewsItemCommentList);
var NewsItemCommentList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemCommentList__StyledWrapper",
    componentId: "sc-93637ab0-0"
})(NewsItemCommentList_templateObject1());


/***/ }),

/***/ 30691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewsItemContent_NewsItemContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./node_modules/interweave-autolink/esm/index.js
var interweave_autolink_esm = __webpack_require__(41366);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(25171);
;// CONCATENATED MODULE: ./src/app.components/ErrorBoundary.tsx






var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.toggleTooltip = function() {
            _this.setState(function(prevState) {
                return {
                    showTooltip: !prevState.showTooltip
                };
            });
        };
        _this.state = {
            hasError: false,
            errorInfo: null,
            showTooltip: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        this.setState({
            errorInfo: JSON.stringify(errorInfo.componentStack || errorInfo)
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                style: {
                                    color: "red"
                                },
                                children: "[에러]"
                            }),
                            " 무언가 잘못 되었습니다..!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: (0,_object_spread/* default */.Z)({
                            position: "relative",
                            fontSize: 14,
                            color: "gray",
                            cursor: "pointer",
                            overflow: "visible"
                        }, this.state.showTooltip && {
                            minHeight: "300px"
                        }),
                        onMouseEnter: this.toggleTooltip,
                        onMouseLeave: this.toggleTooltip,
                        children: [
                            "에러 정보",
                            this.state.showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    height: "100%",
                                    width: "100%",
                                    backgroundColor: "black",
                                    color: "white",
                                    padding: "5px",
                                    borderRadius: "3px",
                                    zIndex: 1,
                                    fontSize: "14px",
                                    overflow: "auto"
                                },
                                children: this.state.errorInfo
                            })
                        ]
                    })
                ]
            });
        }
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(_error) {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var app_components_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ./src/app.feature/channel/hook/useExpendBtn.tsx
var useExpendBtn = __webpack_require__(14653);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/hook/useTagEffect.ts
var useTagEffect = __webpack_require__(88916);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemImageSlider.tsx + 3 modules
var NewsItemImageSlider = __webpack_require__(56956);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/NewsItemContent.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemContent_NewsItem on NewsItem {\n    id\n    content\n    images {\n      nodes {\n        id\n        url\n      }\n    }\n    embed {\n      id\n      imageUrl\n      description\n      domain\n      url\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  & > .description {\n    padding: 0 20px 0px;\n    line-height: 24px;\n    height: 96px;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n    a {\n      color: rgb(1, 160, 255) !important;\n    }\n    .ql-hashtag {\n      color: ",
        ";\n      font-weight: 400;\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n    .expend-cancle-btn {\n      font-size: 12px;\n      cursor: pointer;\n    }\n    &[data-expend='true'] {\n      height: fit-content;\n      margin-bottom: 12px;\n    }\n  }\n  .slider {\n    -webkit-tap-highlight-color: transparent;\n  }\n  & > .expend-btn {\n    margin: 5px 20px 12px;\n    color: #777;\n    font-size: 12px;\n    cursor: pointer;\n  }\n  .embed-card {\n    background-color: #f5fafd;\n    .content-wrapper {\n      overflow: hidden;\n      padding: 30px 20px;\n      .embed-title {\n        margin-bottom: 4px;\n        vertical-align: middle;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        overflow-wrap: break-word;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n      }\n      .embed-subtitle {\n        color: #9f9f9f;\n        font-size: 14px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n    }\n    &[data-small='true'] {\n      display: flex;\n      .img-wrapper {\n        flex-shrink: 0;\n        padding: 20px 0 15px 20px;\n        img {\n          height: 95px;\n        }\n      }\n      .content-wrapper {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n      }\n    }\n    &[data-small='false'] {\n      .img-wrapper {\n        position: relative;\n        width: 100%;\n        background-color: #333;\n        &:after {\n          content: '';\n          display: block;\n          padding-bottom: 60%;\n        }\n        .img {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          object-position: center center;\n        }\n      }\n    }\n  }\n  &[data-type='card'] {\n    height: 412px;\n    flex-grow: 1;\n    .embed-card {\n      .img-wrapper {\n        max-height: 160px;\n      }\n      .content-wrapper {\n        padding: 20px;\n      }\n    }\n    .description {\n      height: 24px;\n      &[data-expend='true'] {\n        margin-bottom: 12px;\n      }\n    }\n    .expend-btn {\n      margin: 2px 20px 16px;\n    }\n  }\n  &[data-no-image='true'] {\n    .description {\n      height: 288px;\n    }\n  }\n  &[data-expend='true'] {\n    .description {\n      height: fit-content;\n      margin-bottom: 12px;\n    }\n  }\n  ",
        " {\n    .embed-card {\n      .content-wrapper {\n        padding: 15px 20px 20px 15px;\n      }\n      &[data-small='true'] {\n        .img-wrapper {\n          padding: 15px 0 10px 20px;\n          img {\n            height: 75px;\n          }\n        }\n      }\n    }\n    &[data-type='card'] {\n      .description {\n        font-size: 14px;\n        height: 24px;\n      }\n      .expend-btn {\n        margin: 0px 15px 10px;\n      }\n    }\n    &[data-no-image='true'] {\n      .description {\n        height: 200px;\n      }\n    }\n    &[data-type='modal'] {\n      .description {\n        z-index: 1;\n        color: white;\n        height: 24px;\n        background-color: rgba(51, 51, 51, 0.7);\n      }\n      .expend-btn {\n        color: white;\n      }\n      &[data-expend='true'] {\n        .description {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          height: fit-content;\n          max-height: 400px;\n          overflow: scroll;\n          padding-bottom: 20px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














src_default()(_templateObject());
var NewsItemContent = function(param) {
    var _type = param.type, type = _type === void 0 ? "feed" : _type, data = param.data, _expendContent = param.expendContent, expendContent = _expendContent === void 0 ? false : _expendContent, onContentClick = param.onContentClick, onImageClick = param.onImageClick, className = param.className;
    // 서버렌더링에서 Interweave가 window/document를 체크하면서 HTML을 그리지 못함 ->ssr렌더러 사용
    if (false) {}
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExpendBtn/* default */.Z)(expendContent), 4), isExpended = ref[0], descriptionRef = ref[1], handleExpendBtn = ref[2], handleCancleExpendBtn = ref[3];
    var ref1 = (0,react.useState)({
        visible: false,
        width: 0,
        height: 0
    }), embedImgState = ref1[0], setEmbedImgState = ref1[1];
    var isNoImage = type === "card" && data.images.nodes.length === 0 && !data.embed;
    (0,react.useEffect)(function() {
        var ref;
        if (false) {}
        if (!((ref = data.embed) === null || ref === void 0 ? void 0 : ref.imageUrl)) return;
        var embedImg = new Image();
        embedImg.onload = function() {
            setEmbedImgState({
                visible: embedImg.width !== 0,
                width: embedImg.width,
                height: embedImg.height
            });
        };
        embedImg.src = data.embed.imageUrl;
    }, [
        data.embed
    ]);
    (0,useTagEffect/* default */.Z)(descriptionRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        "data-type": type,
        "data-expend": isExpended,
        "data-no-image": isNoImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "description",
                ref: descriptionRef,
                onClick: onContentClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(app_components_ErrorBoundary, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Interweave */.wZ, {
                            content: data.content,
                            matchers: [
                                new interweave_autolink_esm/* UrlMatcher */.xc("url")
                            ]
                        })
                    }),
                    type === "modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "expend-cancle-btn",
                        onClick: function() {
                            if (!descriptionRef.current) return;
                            descriptionRef.current.scrollTo(0, 0);
                            handleCancleExpendBtn();
                        },
                        children: "더보기 취소"
                    })
                ]
            }),
            isExpended === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "expend-btn",
                onClick: type === "card" ? onContentClick : handleExpendBtn,
                children: "...더보기"
            }),
            data.images.nodes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemImageSlider/* default */.Z, {
                className: "slider",
                data: data.images.nodes,
                type: type,
                onClick: onImageClick
            }),
            data.embed && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: data.embed.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "embed-card",
                    "data-small": embedImgState.width <= 600,
                    target: "_blank",
                    children: [
                        embedImgState.visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "img-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "img",
                                src: data.embed.imageUrl,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "embed-title",
                                    children: data.embed.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "embed-subtitle",
                                    children: data.embed.domain
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var NewsItemContent_NewsItemContent = (NewsItemContent);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemContent__StyledWrapper",
    componentId: "sc-251006c0-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
}, media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 46030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ NewsItemContent_NewsItemContentLoading; },
  "Z": function() { return /* binding */ component_NewsItemContent; }
});

// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/NewsItemContent.tsx + 1 modules
var NewsItemContent = __webpack_require__(30691);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/NewsItemContentLoading.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .description {\n    margin: 0 20px 12px;\n    .line {\n      width: 100%;\n      height: 22px;\n      background-color: #eee;\n      border-radius: 5px;\n      margin-bottom: 10px;\n    }\n  }\n\n  ",
        " {\n    &[data-type='card'] {\n      .description {\n        margin: 0 15px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NewsItemContentLoading = function(param) {
    var _type = param.type, type = _type === void 0 ? "feed" : _type, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "description",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "NewsItemImageSlider"
            })
        ]
    });
};
/* harmony default export */ var NewsItemContent_NewsItemContentLoading = (NewsItemContentLoading);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemContentLoading__StyledWrapper",
    componentId: "sc-80e84b4d-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/index.tsx



/* harmony default export */ var component_NewsItemContent = (NewsItemContent/* default */.Z);


/***/ }),

/***/ 53505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewsItemFooter_NewsItemFooter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 2 modules
var notistack_esm = __webpack_require__(29496);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/SnackbarLink/SnackbarLink.tsx
var SnackbarLink = __webpack_require__(83821);
// EXTERNAL MODULE: ./src/app.components/modals/ShareModal/index.tsx + 2 modules
var ShareModal = __webpack_require__(20503);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.constants/enums.ts
var enums = __webpack_require__(57628);
;// CONCATENATED MODULE: ./src/app.feature/channel/hook/useNewsReactionData.ts




var defaultImage = {
    channel: "/static/images/channel/enterprise.png",
    user: "/static/images/channel/user-profile.png"
};
var useNewsReactionData = function(data, currentTab) {
    var ref, ref1;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var getUserType = function(user) {
        if ((user === null || user === void 0 ? void 0 : user.__typename) === "Channel") {
            return enums/* ChannelUserType.CHANNEL */.r.CHANNEL;
        } else {
            return (user === null || user === void 0 ? void 0 : user.type) === graphql/* UserType.NORMAL */.FWD.NORMAL ? enums/* ChannelUserType.NORMAL */.r.NORMAL : enums/* ChannelUserType.OWNER */.r.OWNER;
        }
    };
    var getUserName = function(user, type) {
        if (type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL) return user.name;
        if (type === enums/* ChannelUserType.OWNER */.r.OWNER) return user === null || user === void 0 ? void 0 : user.organization.name;
        return user.username;
    };
    var getImageUrl = function(user, type) {
        var ref;
        if (type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL) return ((ref = user.owner.logoImage) === null || ref === void 0 ? void 0 : ref.url) || defaultImage.channel;
        if (type === enums/* ChannelUserType.NORMAL */.r.NORMAL) return user.avatarUrl || defaultImage.user;
        return defaultImage.user;
    };
    var getChannelUrl = function(user, type) {
        if (type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL) return (0,util/* getWebviewHref */.ys)("/channel/".concat(user.url), isWebview);
        return "";
    };
    var nodes = currentTab === "scrap" ? data === null || data === void 0 ? void 0 : (ref = data.bookmarkers) === null || ref === void 0 ? void 0 : ref.nodes : data === null || data === void 0 ? void 0 : (ref1 = data.likers) === null || ref1 === void 0 ? void 0 : ref1.nodes;
    var dataSet = nodes === null || nodes === void 0 ? void 0 : nodes.map(function(user) {
        var ref, ref1;
        var userType = getUserType(user);
        var newsItems = currentTab === "scrap" ? (user === null || user === void 0 ? void 0 : (ref = user.bookmarks) === null || ref === void 0 ? void 0 : ref.nodes) || [] : (user === null || user === void 0 ? void 0 : (ref1 = user.likes) === null || ref1 === void 0 ? void 0 : ref1.nodes) || [];
        return {
            id: user === null || user === void 0 ? void 0 : user.id,
            type: userType,
            name: getUserName(user, userType),
            description: userType === enums/* ChannelUserType.CHANNEL */.r.CHANNEL ? user.briefDescription : "",
            channelUrl: getChannelUrl(user, userType),
            imageUrl: getImageUrl(user, userType),
            viewerIsOwner: (user === null || user === void 0 ? void 0 : user.viewerIsOwner) || false,
            viewerHasFollowed: (user === null || user === void 0 ? void 0 : user.viewerHasFollowed) || false,
            currentTab: currentTab,
            newsItem: newsItems.slice(0, 2).map(function(newsItem) {
                var ref;
                return {
                    id: newsItem.id,
                    content: newsItem.content.replace(/<[^>]*>?/g, ""),
                    newsItemUrl: (0,util/* getWebviewHref */.ys)("/channel/".concat((ref = newsItem.channel) === null || ref === void 0 ? void 0 : ref.url, "/").concat(newsItem.id), isWebview)
                };
            }) || []
        };
    });
    return {
        dataSet: dataSet
    };
};
/* harmony default export */ var hook_useNewsReactionData = (useNewsReactionData);

// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useChannelError.ts
var useChannelError = __webpack_require__(65982);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionUserModal.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 340px;\n  height: 360px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 20px;\n  gap: 20px;\n  .close-icon {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    svg {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n    }\n  }\n  .logo-img {\n    width: 94px;\n    height: 94px;\n    background-color: #eee;\n    border-radius: 50%;\n    object-fit: cover;\n    &[data-channel='true'] {\n      border-radius: 17px;\n      border: 1px solid #ddd;\n    }\n  }\n  .user-title {\n    width: 240px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: center;\n  }\n  .channel-info {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 20px;\n    .channel-content {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      .channel-desc {\n        width: 240px;\n        max-height: 60px;\n        font-size: 14px;\n        font-weight: 500;\n        text-align: center;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n    .channel-btn {\n      width: 117px;\n      height: 45px;\n      margin-top: 8px;\n    }\n  }\n  .news-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    .news-item {\n      width: 181px;\n      height: 38px;\n      display: flex;\n      align-items: center;\n      padding: 0 15px;\n      background-color: #f2faff;\n      border: 1px solid #add8e6;\n      border-radius: 5px;\n      span {\n        font-size: 12px;\n      }\n      svg {\n        width: 10px;\n        height: 10px;\n        margin-top: 1px;\n      }\n    }\n  }\n  .ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var NewsReactionUserModal_defaultImage = {
    normal: "/static/images/channel/user-profile.png",
    channel: "/static/images/channel/enterprise.png"
};
var NewsReactionUserModal = function(_param) {
    var data = _param.data, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onClose"
    ]);
    var isWebview = (0,useIsWebview/* default */.Z)();
    var isChannel = (0,react.useMemo)(function() {
        return data.type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL;
    }, [
        data
    ]);
    var userTitleText = (0,react.useMemo)(function() {
        return data.currentTab === "scrap" ? "최근에 스크랩한 소식" : "최근에 좋아요를 누른 소식";
    }, [
        data
    ]);
    var fallbackImageProps = (0,utils/* useFallbackImageInSSR */.DN)(NewsReactionUserModal_defaultImage[data.type]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isModalOverlapping: true,
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                    className: "logo-img",
                    src: data.imageUrl,
                    alt: "프로필 사진",
                    "data-channel": isChannel
                }, fallbackImageProps)),
                isChannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "channel-info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "channel-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "user-title ellipsis",
                                    children: data.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "channel-desc",
                                    children: data.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.channelUrl + "#top",
                            replace: !isWebview,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "channel-btn",
                                    children: "채널 바로가기"
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "user-title",
                            children: userTitleText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "news-list",
                            children: data.newsItem.map(function(news) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: news.newsItemUrl,
                                    replace: !isWebview,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "news-item",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ellipsis",
                                                children: news.content
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                                        ]
                                    })
                                }, news.id);
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var NewsReactionModal_NewsReactionUserModal = (NewsReactionUserModal);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionUserModal__StyledWrapper",
    componentId: "sc-85f11fca-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionCard.tsx



function NewsReactionCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 69px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #eee;\n  .lt {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    &[data-cursor='true'] {\n      cursor: pointer;\n    }\n    .logo-img {\n      width: 48px;\n      height: 48px;\n      background-color: #eee;\n      border-radius: 50%;\n      object-fit: cover;\n      &[data-channel='true'] {\n        border-radius: 5px;\n        border: 1px solid #ddd;\n      }\n    }\n    .user-content {\n      display: flex;\n      align-items: center;\n    }\n    .name {\n      font-size: 16px;\n      font-weight: 500;\n    }\n    .desc {\n      font-size: 12px;\n      font-weight: 500;\n      margin-top: 2px;\n    }\n    svg {\n      margin: 2px 0 0 2px;\n      width: 11px;\n      height: 11px;\n    }\n  }\n  .follow-btn {\n    width: 78px;\n    height: 36px;\n    font-size: 14px;\n    font-weight: bold;\n    flex-shrink: 0;\n  }\n  .ellipsis {\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  ",
        " {\n    .lt {\n      .name {\n        font-size: 14px;\n      }\n      .desc {\n        font-weight: 400;\n      }\n    }\n    .ellipsis {\n      max-width: 160px;\n    }\n  }\n"
    ]);
    NewsReactionCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var NewsReactionCard = function(param) {
    var data = param.data;
    var onError = (0,useChannelError/* default */.Z)();
    var followChannelMutation = (0,graphql/* useFollowChannelMutation */.R7_)({
        onError: onError
    });
    var ref = (0,react.useState)(false), userModalOpen = ref[0], setUserModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), loginModalOpen = ref1[0], setLoginModalOpen = ref1[1];
    var ref2 = (0,graphql/* useCurrentUserQuery */.rkO)(), currentUser = ref2.data;
    var fallbackImageProps = (0,utils/* useFallbackImageInSSR */.DN)(NewsReactionUserModal_defaultImage[data.type]);
    var handleFollowBtn = function() {
        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.currentUser)) return setLoginModalOpen(true);
        if (!data.viewerHasFollowed) {
            var _followChannelMutation = (0,_sliced_to_array/* default */.Z)(followChannelMutation, 1), mutate = _followChannelMutation[0];
            mutate({
                variables: {
                    channelId: data.id
                }
            });
        }
    };
    var handleCardClick = function() {
        if (data.type === enums/* ChannelUserType.OWNER */.r.OWNER) return;
        setUserModalOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsReactionCard_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                onClick: handleCardClick,
                "data-cursor": data.type !== enums/* ChannelUserType.OWNER */.r.OWNER,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                        className: "logo-img",
                        src: data.imageUrl,
                        alt: "프로필 사진",
                        "data-channel": data.type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL
                    }, fallbackImageProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "user-content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "name ellipsis",
                                        children: data.name
                                    }),
                                    data.type !== enums/* ChannelUserType.OWNER */.r.OWNER && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                                ]
                            }),
                            data.type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc ellipsis",
                                children: data.description
                            })
                        ]
                    })
                ]
            }),
            data.type === enums/* ChannelUserType.CHANNEL */.r.CHANNEL && !data.viewerIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "follow-btn",
                onClick: handleFollowBtn,
                disabled: data.viewerHasFollowed,
                color: data.viewerHasFollowed ? "lightGrey2" : "primary",
                variant: data.viewerHasFollowed ? "contained" : "outlined",
                children: data.viewerHasFollowed ? "팔로우중" : "+팔로우"
            }),
            userModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionUserModal, {
                data: data,
                open: userModalOpen,
                onClose: function() {
                    return setUserModalOpen(false);
                }
            }),
            loginModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpen
                },
                onRequestClose: function() {
                    return setLoginModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var NewsReactionModal_NewsReactionCard = (NewsReactionCard);
var NewsReactionCard_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionCard__StyledWrapper",
    componentId: "sc-72d49db9-0"
})(NewsReactionCard_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionEmpty.tsx

function NewsReactionEmpty_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 150px;\n  img {\n    height: 92px;\n    margin-bottom: 8px;\n  }\n  .empty-title {\n    font-size: 20px;\n    font-weight: 500;\n    color: #666;\n  }\n  .empty-desc {\n    margin-top: 5px;\n    font-size: 15px;\n    color: #999;\n  }\n"
    ]);
    NewsReactionEmpty_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NewsReactionEmpty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsReactionEmpty_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/static/images/channel/recruit.png",
                alt: "enterprise"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "empty-title",
                children: "아직 반응이 없는 소식입니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "empty-desc",
                children: "가장 먼저 반응을 남기고 관심을 표시해보세요."
            })
        ]
    });
};
/* harmony default export */ var NewsReactionModal_NewsReactionEmpty = (NewsReactionEmpty);
var NewsReactionEmpty_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionEmpty__StyledWrapper",
    componentId: "sc-1a3fb3db-0"
})(NewsReactionEmpty_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionLoading.tsx

function NewsReactionLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 30px;\n  gap: 10px;\n  .loading {\n    background-color: #eee;\n    border-radius: 5px;\n    height: 30px;\n  }\n"
    ]);
    NewsReactionLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NewsReactionLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionLoading_StyledWrapper, {
        children: new Array(5).fill("").map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading"
            }, index);
        })
    });
};
/* harmony default export */ var NewsReactionModal_NewsReactionLoading = (NewsReactionLoading);
var NewsReactionLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionLoading__StyledWrapper",
    componentId: "sc-63e44eb8-0"
})(NewsReactionLoading_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionList.tsx

function NewsReactionList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  padding: 0 30px;\n\n  ",
        " {\n    padding: 0 20px;\n  }\n"
    ]);
    NewsReactionList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var NewsReactionList = function(param) {
    var data = param.data, loading = param.loading;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionLoading, {});
    if (!loading && !data.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionEmpty, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionList_StyledWrapper, {
        children: data.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionCard, {
                data: item
            }, item.name);
        })
    });
};
/* harmony default export */ var NewsReactionModal_NewsReactionList = (NewsReactionList);
var NewsReactionList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionList__StyledWrapper",
    componentId: "sc-414985fa-0"
})(NewsReactionList_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/NewsReactionModal/NewsReactionModal.tsx




function NewsReactionModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsReactionModal_User on User {\n    id\n    type\n    username\n    avatarUrl\n    bookmarks {\n      nodes {\n        id\n        content\n        channel {\n          id\n          url\n        }\n      }\n    }\n    likes {\n      nodes {\n        id\n        content\n        channel {\n          id\n          url\n        }\n      }\n    }\n    organization {\n      id\n      name\n      logoImage {\n        id\n        url\n      }\n    }\n  }\n\n  fragment NewsReactionModal_Channel on Channel {\n    id\n    url\n    name\n    briefDescription\n    viewerIsOwner\n    viewerHasFollowed\n    owner {\n      id\n      logoImage {\n        id\n        url\n      }\n    }\n  }\n\n  fragment NewsReactionModal_NewsItem on NewsItem {\n    id\n    likers {\n      totalCount\n      nodes {\n        ...NewsReactionModal_User\n        ...NewsReactionModal_Channel\n      }\n    }\n    bookmarkers {\n      nodes {\n        ...NewsReactionModal_User\n        ...NewsReactionModal_Channel\n      }\n    }\n  }\n\n  query gqlNewsReactionModal($id: ID!) {\n    newsItem(id: $id) {\n      ...NewsReactionModal_NewsItem\n    }\n  }\n"
    ]);
    NewsReactionModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 550px;\n  height: 640px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 20px;\n  .header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 30px 30px 5px;\n    .modal-title {\n      font-size: 20px;\n      font-weight: 500;\n    }\n    svg {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n    }\n    .mobile-close {\n      display: none;\n      position: absolute;\n      top: 20px;\n      left: 20px;\n    }\n  }\n  .tab-box {\n    display: flex;\n    border-bottom: 1px solid #eee;\n    .tab {\n      width: 100%;\n      height: 50px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 16px;\n      font-weight: 500;\n      &[data-active='true'] {\n        color: #01a0ff;\n        font-weight: bold;\n        border-bottom: 2px solid #01a0ff;\n      }\n    }\n  }\n\n  ",
        " {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    transform: none;\n    border-radius: 0;\n    .header {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      padding: 20px;\n      .modal-title {\n        font-size: 16px;\n        font-weight: bold;\n      }\n      .mobile-close {\n        display: block;\n      }\n      .desktop-close {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













src_default()(NewsReactionModal_templateObject());
var NewsReactionModal = function(_param) {
    var onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var ref = (0,react.useState)("like"), currentTab = ref[0], setCurrentTab = ref[1];
    var ref1 = (0,graphql/* useGqlNewsReactionModalQuery */.o1v)({
        variables: {
            id: "".concat(router.query.id)
        }
    }), data = ref1.data, loading = ref1.loading;
    (0,react.useEffect)(function() {
        setCurrentTab("".concat(router.query.modal));
    }, [
        router.query
    ]);
    var tabList = (0,react.useMemo)(function() {
        return [
            {
                label: "좋아요",
                active: currentTab === "like",
                onClick: function() {
                    return setCurrentTab("like");
                }
            },
            {
                label: "스크랩",
                active: currentTab === "scrap",
                onClick: function() {
                    return setCurrentTab("scrap");
                }
            }, 
        ];
    }, [
        currentTab
    ]);
    var dataSet = hook_useNewsReactionData(data === null || data === void 0 ? void 0 : data.newsItem, currentTab).dataSet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        animation: isMobile ? "left" : "fade",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsReactionModal_StyledWrapper, {
            children: [
                !isWebview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowLeft */.Xd, {
                            className: "mobile-close",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-title",
                            children: "소식 반응"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                            className: "desktop-close",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tab-box",
                    children: tabList.map(function(tab) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "tab",
                            "data-active": tab.active,
                            onClick: tab.onClick,
                            children: tab.label
                        }, tab.label);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionList, {
                    data: dataSet,
                    loading: loading
                })
            ]
        })
    }));
};
/* harmony default export */ var NewsReactionModal_NewsReactionModal = (NewsReactionModal);
var NewsReactionModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsReactionModal__StyledWrapper",
    componentId: "sc-94707ab5-0"
})(_templateObject1(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/svgIcons/Comment.tsx

function Comment(param) {
    var _color = param.color, color = _color === void 0 ? "#777" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-label": "댓글",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "댓글"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z",
                "data-name": "Rectangle Copy 26"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "data-name": "그룹 9419",
                transform: "translate(4.763 4.876)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        stroke: color,
                        strokeMiterlimit: "10",
                        strokeWidth: "1.5",
                        d: "M6.9.013A7.123 7.123 0 00.895 10.135a.528.528 0 01.032.369l-.914 3.224a.323.323 0 00.39.4l3.2-.809a.424.424 0 01.308.042A7.124 7.124 0 106.9.013z",
                        "data-name": "패스 5075"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "1.15",
                        cy: "1.15",
                        r: "1.15",
                        fill: color,
                        "data-name": "타원 830",
                        transform: "translate(3.086 5.974)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "1.15",
                        cy: "1.15",
                        r: "1.15",
                        fill: color,
                        "data-name": "타원 831",
                        transform: "translate(6.042 5.974)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "1.15",
                        cy: "1.15",
                        r: "1.15",
                        fill: color,
                        "data-name": "타원 832",
                        transform: "translate(9.086 5.974)"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var svgIcons_Comment = (Comment);

// EXTERNAL MODULE: ./src/svgIcons/Like.tsx
var Like = __webpack_require__(56031);
;// CONCATENATED MODULE: ./src/svgIcons/Scrap.tsx

function Scrap(param) {
    var _color = param.color, color = _color === void 0 ? "#777" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "스크랩",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "스크랩"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "5utw0hroka",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        stroke: color,
                        d: "M0 0h20v20H0z",
                        "data-name": "사각형 3304",
                        transform: "translate(1392.5 570.5)"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#5utw0hroka)",
                "data-name": "마스크 그룹 99",
                transform: "translate(-1392.5 -570.5)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "none",
                    stroke: color,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.2",
                    d: "M1407.11 586.427l-4.61-3.293-4.61 3.293V575.89a1.317 1.317 0 011.317-1.317h6.583a1.317 1.317 0 011.32 1.317z",
                    "data-name": "bookmark (1)"
                })
            })
        ]
    });
}
/* harmony default export */ var svgIcons_Scrap = (Scrap);

// EXTERNAL MODULE: ./src/svgIcons/ShareLight.tsx
var ShareLight = __webpack_require__(32685);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemFooter/NewsItemFooter.tsx






function NewsItemFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemFooter_NewsItem on NewsItem {\n    id\n    likers {\n      totalCount\n    }\n    comments {\n      totalCount\n    }\n    channel {\n      id\n      url\n      viewerHasFollowed\n    }\n    shareCount\n    viewerHasLiked\n    bookmarkCount\n    viewerHasBookmarked\n    newsCommentCount\n  }\n"
    ]);
    NewsItemFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsItemFooter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 20px 0;\n\n  .count-text {\n    border: none;\n    padding: 0px;\n    background: none;\n    font-size: 15px;\n    line-height: 1.33;\n    font-weight: 400;\n  }\n  .counts {\n    display: flex;\n    justify-content: space-between;\n    font-size: 15px;\n    line-height: 1.33;\n    font-weight: 400;\n    color: #333;\n    padding: 16px 0;\n    .info-list {\n      display: flex;\n      gap: 8px;\n    }\n  }\n  .hr {\n    height: 1px;\n    background-color: #eeeeee;\n  }\n  .btns {\n    display: flex;\n    padding: 8px 0;\n    .btn {\n      cursor: pointer;\n      background-color: white;\n      border: none;\n      flex-grow: 1;\n      text-align: center;\n      color: #777777;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 12px 0px;\n      border-radius: 5px;\n      &.active {\n        color: #01a0ff;\n      }\n      &:hover {\n        background-color: #f5f5f5;\n      }\n      &.scrap {\n        &[data-fill='true'] {\n          color: #01a0ff;\n          svg {\n            width: 20px;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n  &[data-type='modal'] {\n    .btns {\n      padding-top: 4px;\n      font-size: 14px;\n      .btn {\n        gap: 0;\n      }\n    }\n  }\n  &[data-type='card'] {\n    .counts {\n      padding: 8px 0;\n      .info-list {\n        height: 17px;\n      }\n    }\n    .btns {\n      font-size: 14px;\n    }\n  }\n  ",
        " {\n    padding: 0px 15px 0;\n    .btns {\n      .btn {\n        background-color: transparent;\n        &:hover {\n          background-color: transparent;\n        }\n      }\n    }\n\n    .count-text {\n      border: none;\n      padding: 0px;\n      background: none;\n      font-size: 15px;\n      line-height: 1.33;\n      font-weight: 400;\n    }\n    &[data-type='modal'] {\n      padding: 0px 20px 0;\n      .count-text {\n        color: #fff;\n      }\n      .counts {\n        color: white;\n        .info-list {\n          button {\n            color: white;\n          }\n        }\n      }\n      .btns {\n        .btn {\n          color: white;\n        }\n      }\n    }\n    &[data-type='card'] {\n      .btns {\n        .btn {\n          padding: 4px 0px;\n        }\n      }\n    }\n  }\n"
    ]);
    NewsItemFooter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






















src_default()(NewsItemFooter_templateObject());
var NewsItemFooter = function(param) {
    var _type = param.type, type = _type === void 0 ? "feed" : _type, data = param.data, _isCommentListOpened = param.isCommentListOpened, isCommentListOpened = _isCommentListOpened === void 0 ? false : _isCommentListOpened, onCommentBtnClick = param.onCommentBtnClick, className = param.className, ogData = param.ogData;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var ref = (0,react.useState)(false), shareModalOpen = ref[0], setShareModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), loginModalOpen = ref1[0], setLoginModalOpen = ref1[1];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var addLikeMutation = (0,graphql/* useAddLikeMutation */.RTe)({
        onError: onError
    });
    var removeLikeMutation = (0,graphql/* useRemoveLikeMutation */.suh)({
        onError: onError
    });
    var addScrapMutation = (0,graphql/* useAddScrapMutation */.PgH)({
        onError: onError
    });
    var removeScrapMutation = (0,graphql/* useRemoveScrapMutation */.uFI)({
        onError: onError
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useIncrementShareCountMutation */.cC4)(), 1), incrementShareCountMutate = ref2[0];
    var incrementShareCountWithPlatform = function(platform) {
        incrementShareCountMutate({
            variables: {
                newsItemId: data.id,
                platform: platform
            }
        });
    };
    var handleLikeBtnClick = function() {
        var ref;
        if (!((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) return setLoginModalOpen(true);
        if (!data.viewerHasLiked) {
            var _addLikeMutation = (0,_sliced_to_array/* default */.Z)(addLikeMutation, 1), mutate = _addLikeMutation[0];
            mutate({
                variables: {
                    newsItemId: "".concat(data.id)
                }
            });
        }
        if (data.viewerHasLiked) {
            var _removeLikeMutation = (0,_sliced_to_array/* default */.Z)(removeLikeMutation, 1), mutate1 = _removeLikeMutation[0];
            mutate1({
                variables: {
                    newsItemId: "".concat(data.id)
                }
            });
        }
    };
    var handleScrapBtnClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, _addScrapMutation, mutate, _removeScrapMutation, mutate1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) return [
                            2,
                            setLoginModalOpen(true)
                        ];
                        if (!!data.viewerHasBookmarked) return [
                            3,
                            2
                        ];
                        _addScrapMutation = (0,_sliced_to_array/* default */.Z)(addScrapMutation, 1), mutate = _addScrapMutation[0];
                        return [
                            4,
                            mutate({
                                variables: {
                                    newsItemId: "".concat(data.id)
                                },
                                refetchQueries: [
                                    {
                                        query: graphql/* PageLayoutDocument */.TbJ,
                                        variables: {
                                            notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                                        }
                                    }
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (!((ref1 = data.channel) === null || ref1 === void 0 ? void 0 : ref1.viewerHasFollowed) && data.channel) {
                            enqueueSnackbar("이 게시글을 등록한 기업을 팔로우했습니다.", {
                                action: /*#__PURE__*/ (0,jsx_runtime.jsx)(SnackbarLink/* default */.Z, {
                                    href: "/channel/".concat(data.channel.url)
                                })
                            });
                        }
                        _state.label = 2;
                    case 2:
                        if (data.viewerHasBookmarked) {
                            _removeScrapMutation = (0,_sliced_to_array/* default */.Z)(removeScrapMutation, 1), mutate1 = _removeScrapMutation[0];
                            mutate1({
                                variables: {
                                    newsItemId: "".concat(data.id)
                                },
                                refetchQueries: [
                                    {
                                        query: graphql/* PageLayoutDocument */.TbJ,
                                        variables: {
                                            notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                                        }
                                    }
                                ]
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScrapBtnClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeReactionModal = function() {
        var query = router.query;
        delete query.modal;
        delete query.id;
        router.push({
            query: (0,_object_spread/* default */.Z)({}, query)
        }, undefined, {
            shallow: true
        });
    };
    var newsItemUrl = (0,react.useMemo)(function() {
        var ref;
        if (false) {}
        return "".concat(window.location.origin, "/channel/").concat((ref = data.channel) === null || ref === void 0 ? void 0 : ref.url, "/").concat(data.id);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItemFooter_StyledWrapper, {
                className: className,
                "data-type": type,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "counts",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: !isWebview ? {
                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                        modal: "like",
                                        id: data.id
                                    })
                                } : "",
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "count-text",
                                    children: data.likers.totalCount !== 0 && "좋아요 ".concat(data.likers.totalCount)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "info-list",
                                children: [
                                    data.newsCommentCount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "count-text",
                                        onClick: onCommentBtnClick,
                                        children: [
                                            "댓글 ",
                                            data.newsCommentCount
                                        ]
                                    }),
                                    data.shareCount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "공유 ",
                                            data.shareCount
                                        ]
                                    }),
                                    data.bookmarkCount !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: !isWebview ? {
                                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                                modal: "scrap",
                                                id: data.id
                                            })
                                        } : "",
                                        shallow: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "count-text",
                                            children: [
                                                "스크랩 ",
                                                data.bookmarkCount
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "btns",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn ".concat(data.viewerHasLiked ? "active" : ""),
                                onClick: handleLikeBtnClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Like/* default */.Z, {
                                        color: data.viewerHasLiked ? "#01a0ff" : undefined
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (type !== "card" || !isMobile) && "좋아요"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn ".concat(isCommentListOpened ? "active" : ""),
                                onClick: onCommentBtnClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_Comment, {
                                        color: isCommentListOpened ? "#01a0ff" : undefined
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (type !== "card" || !isMobile) && "댓글"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn",
                                onClick: function() {
                                    if (onError()) return;
                                    setShareModalOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLight/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (type !== "card" || !isMobile) && "공유하기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "btn scrap",
                                onClick: handleScrapBtnClick,
                                "data-fill": data.viewerHasBookmarked,
                                children: [
                                    data.viewerHasBookmarked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* BookMark */.QC, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_Scrap, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (type !== "card" || !isMobile) && "스크랩"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            shareModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                shareLink: newsItemUrl,
                open: shareModalOpen,
                onClick: incrementShareCountWithPlatform,
                onClose: function() {
                    return setShareModalOpen(false);
                },
                ogImage: ogData === null || ogData === void 0 ? void 0 : ogData.image,
                title: ogData === null || ogData === void 0 ? void 0 : ogData.title
            }),
            router.query.id === data.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsReactionModal_NewsReactionModal, {
                open: true,
                onClose: closeReactionModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpen
                },
                onRequestClose: function() {
                    return setLoginModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var NewsItemFooter_NewsItemFooter = (NewsItemFooter);
var NewsItemFooter_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemFooter__StyledWrapper",
    componentId: "sc-e8ba5bf9-0"
})(NewsItemFooter_templateObject1(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 71387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewsItemHeader_NewsItemHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/UnFollowModal.tsx
var UnFollowModal = __webpack_require__(24388);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useChannelError.ts
var useChannelError = __webpack_require__(65982);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.modules/util/time.tsx
var time = __webpack_require__(20178);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
// EXTERNAL MODULE: ./src/app.components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(57315);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 2 modules
var notistack_esm = __webpack_require__(29496);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.components/Editor/NewsEditor.tsx + 14 modules
var NewsEditor = __webpack_require__(55282);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.components/Editor/components/WriterInfo.tsx
var WriterInfo = __webpack_require__(60125);
;// CONCATENATED MODULE: ./src/app.components/Editor/NewsEditorLoading.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .content-wrapper {\n    margin-top: 12px;\n    display: grid;\n    gap: 8px;\n  }\n\n  .button-wrapper {\n    display: flex;\n    gap: 10px;\n    margin-top: 72px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NewsEditorLoading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WriterInfo/* default */.Z, {
                isLoading: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 150,
                        height: 13
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 100,
                        height: 13
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 80,
                        height: 13
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "button-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 87,
                        height: 46
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 110,
                        height: 46
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Editor_NewsEditorLoading = (NewsEditorLoading);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsEditorLoading__StyledWrapper",
    componentId: "sc-aa495912-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.components/Editor/components/ConfirmCloseModal.tsx
var ConfirmCloseModal = __webpack_require__(14356);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
;// CONCATENATED MODULE: ./src/app.components/modals/NewsItemModifyModal.tsx


function NewsItemModifyModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemModifyModal_attachment on Attachment {\n    id\n    url\n  }\n\n  fragment NewsItemModifyModal_attachmentConnection on AttachmentConnection {\n    totalCount\n    nodes {\n      ...NewsItemModifyModal_attachment\n    }\n  }\n\n  fragment NewsItemModifyModal_embed on Embed {\n    id\n    description\n    domain\n    url\n    imageUrl\n  }\n\n  fragment NewsItemModifyModal_newsItem on NewsItem {\n    id\n    content\n    images {\n      ...NewsItemModifyModal_attachmentConnection\n    }\n    embed {\n      ...NewsItemModifyModal_embed\n    }\n  }\n\n  query gqlNewsItemModifyModal($newsItemId: ID!) {\n    newsItem(id: $newsItemId) {\n      ...NewsItemModifyModal_newsItem\n    }\n  }\n"
    ]);
    NewsItemModifyModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 600px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  border-radius: 15px;\n\n  .recommend-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 32px;\n    font-size: 24px;\n    font-weight: 700;\n    border-bottom: 1px solid #dddddd;\n  }\n\n  .close-button {\n    position: absolute;\n    top: 32px;\n    right: 32px;\n    width: 16px;\n    height: 16px;\n    :hover {\n      cursor: pointer;\n    }\n  }\n\n  .recommend-content {\n    padding: 24px 0 24px 40px;\n    min-height: 294px;\n    max-height: 600px;\n  }\n\n  .recommend-footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid #ddd;\n    padding: 20px 32px 32px;\n    .button {\n      width: 87px;\n      height: 48px;\n      font-size: 16px;\n      color: #fff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(NewsItemModifyModal_templateObject());
var NewsItemModifyModal = function(param) {
    var newsItemId = param.newsItemId, onClose = param.onClose;
    var ref, ref1;
    var editorRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isCanSubmit = ref2[0], setIsCanSubmit = ref2[1];
    var ref3 = (0,react.useState)(false), isDirty = ref3[0], setIsDirty = ref3[1];
    var ref4 = (0,react.useState)(false), closeModalVisible = ref4[0], setCloseModalVisible = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlNewsItemModifyModalLazyQuery */.yOp)(), 2), getNewsItem = ref5[0], ref6 = ref5[1], data = ref6.data, loading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateNewsItemMutation */.WyC)({
        onCompleted: function() {
            onClose();
        }
    }), 1), updateNewsItem = ref7[0];
    var embedData = (0,react.useMemo)(function() {
        var ref;
        var embed = data === null || data === void 0 ? void 0 : (ref = data.newsItem) === null || ref === void 0 ? void 0 : ref.embed;
        if (!embed) {
            return undefined;
        }
        return {
            url: embed.url,
            description: embed.description,
            domain: embed.domain,
            imageUrl: embed.imageUrl
        };
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.newsItem) === null || ref === void 0 ? void 0 : ref.embed
    ]);
    var handleSubmit = function() {
        var ref, ref1;
        var content = ((ref = editorRef.current) === null || ref === void 0 ? void 0 : ref.getValue()) || "";
        var imageIds = ((ref1 = editorRef.current) === null || ref1 === void 0 ? void 0 : ref1.uploadedImageAttachmentIds) || [];
        var tagNames = (0,util/* parseHashtagFromContentHtml */.XJ)(content);
        updateNewsItem({
            variables: {
                input: {
                    id: newsItemId,
                    content: content,
                    imageIds: imageIds,
                    tagNames: tagNames
                }
            }
        });
    };
    var handleClose = function() {
        if (isDirty) {
            setCloseModalVisible(true);
        } else {
            onClose();
        }
    };
    (0,react.useEffect)(function() {
        getNewsItem({
            variables: {
                newsItemId: newsItemId
            }
        });
    }, [
        newsItemId,
        getNewsItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        onClose: handleClose,
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItemModifyModal_StyledWrapper, {
            id: "news-item-modify-modal-".concat(newsItemId),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "recommend-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "소식 수정"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                            className: "close-button",
                            onClick: handleClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "recommend-content",
                    children: [
                        (data === null || data === void 0 ? void 0 : (ref1 = data.newsItem) === null || ref1 === void 0 ? void 0 : ref1.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsEditor/* default */.Z, {
                            ref: editorRef,
                            setIsCanSubmit: setIsCanSubmit,
                            setIsDirty: setIsDirty,
                            initialContent: data.newsItem.content,
                            initialEmbed: embedData,
                            initialImages: data.newsItem.images.nodes.map(function(node) {
                                return {
                                    attachmentID: (node === null || node === void 0 ? void 0 : node.id) || "",
                                    url: (node === null || node === void 0 ? void 0 : node.url) || "",
                                    name: "",
                                    size: 0,
                                    type: ""
                                };
                            }),
                            isModify: true
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_NewsEditorLoading, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "recommend-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSubmit,
                        disabled: !isCanSubmit,
                        className: "button",
                        children: "등록"
                    })
                }),
                closeModalVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmCloseModal/* default */.Z, {
                    onConfirm: onClose,
                    onClose: function() {
                        return setCloseModalVisible(false);
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var modals_NewsItemModifyModal = (NewsItemModifyModal);
var NewsItemModifyModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemModifyModal__StyledWrapper",
    componentId: "sc-78c57e33-0"
})(_templateObject1());

// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/AlreadyReportedModal.tsx
var AlreadyReportedModal = __webpack_require__(79127);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/modals/DeleteNewsItemModal.tsx





function DeleteNewsItemModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 620px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px 0;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n    padding: 0 30px;\n  }\n  .modal-title {\n    width: 100%;\n    font-size: 24px;\n    font-weight: 500;\n    padding-bottom: 30px;\n    text-align: center;\n    border-bottom: 1px solid #eeeeee;\n  }\n  .modal-description {\n    font-size: 16px;\n    margin: 40px 0 30px;\n    padding: 0 70px;\n    width: 100%;\n    p {\n      margin-bottom: 12px;\n    }\n    li {\n      position: relative;\n      margin-bottom: 5px;\n      span {\n        color: #01a0ff;\n      }\n    }\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    DeleteNewsItemModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var DeleteNewsItemModal = function(_param) {
    var onClose = _param.onClose, newsItemId = _param.newsItemId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose",
        "newsItemId"
    ]);
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useDeleteNewsItemMutation */.MPL)({
        onCompleted: function(data) {
            if (router.pathname === (0,util/* getWebviewHref */.ys)("/channel/[channel-url]/[news-id]", isWebview)) {
                var ref;
                router.push((0,util/* getWebviewHref */.ys)("/channel/".concat((ref = data.deleteNewsItem.channel) === null || ref === void 0 ? void 0 : ref.url), isWebview));
            }
            enqueueSnackbar("소식이 삭제되었습니다.");
        },
        onError: onError
    }), 1), deleteNewsItemMutate = ref[0];
    var handleConfirm = function() {
        deleteNewsItemMutate({
            variables: {
                deleteNewsItemId: newsItemId
            }
        });
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteNewsItemModal_StyledWrapper, {
            className: "common-modal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-title",
                    children: "이 소식을 삭제하시겠어요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-description",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "소식을 삭제하는 경우 아래와 같이 조치됩니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "이 소식에 등록된 ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "댓글이 함께 삭제"
                                        }),
                                        " 됩니다."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "이 소식의 ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "‘좋아요, 스크랩, 공유하기’ 데이터가 삭제"
                                        }),
                                        " ",
                                        "됩니다."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "btn",
                            onClick: handleConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var modals_DeleteNewsItemModal = (DeleteNewsItemModal);
var DeleteNewsItemModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeleteNewsItemModal__StyledWrapper",
    componentId: "sc-36aeb538-0"
})(DeleteNewsItemModal_templateObject(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/DesktopOnlyModal.tsx
var DesktopOnlyModal = __webpack_require__(62609);
// EXTERNAL MODULE: ./src/app.feature/channel/component/modals/ReportModal.tsx
var ReportModal = __webpack_require__(44575);
// EXTERNAL MODULE: ./src/app.modules/hooks/useDropdown.tsx
var useDropdown = __webpack_require__(6714);
// EXTERNAL MODULE: ./src/app.feature/channel/component/MoreDropdownBtn.tsx
var MoreDropdownBtn = __webpack_require__(61996);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/DropdownBtn/index.tsx


function DropdownBtn_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  .more-menu-btn {\n    width: 28px;\n    height: 28px;\n    .dot {\n      width: 3.5px;\n      height: 3.5px;\n    }\n  }\n  .more-menu-list {\n    z-index: 2;\n    display: none;\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    border: 1px solid #cccccc;\n    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16);\n    border-radius: 5px;\n    padding: 6px 0;\n    text-align: center;\n    white-space: nowrap;\n    font-size: 12px;\n    background-color: white;\n    .more-menu {\n      border: none;\n      background: none;\n      display: block;\n      padding: 4px 12px;\n      &:hover {\n        background-color: #f8f8f8;\n      }\n    }\n    &[data-open='true'] {\n      display: block;\n    }\n  }\n"
    ]);
    DropdownBtn_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var DropdownBtn = function(param) {
    var data = param.data;
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDropdown/* default */.Z)(), 3), menuRef = ref[0], isDropdownOpened = ref[1], handleDropDownBtn = ref[2];
    var ref1 = (0,react.useState)(false), reportModalOpen = ref1[0], setReportModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), modifyModalOpen = ref2[0], setModifyModalOpen = ref2[1];
    var ref3 = (0,react.useState)(false), deleteNewsItemModalOpen = ref3[0], setDeleteNewsItemModalOpen = ref3[1];
    var ref4 = (0,react.useState)(false), loginModalOpen = ref4[0], setLoginModalOpen = ref4[1];
    var ref5 = (0,react.useState)(false), desktopOnlyModalOpen = ref5[0], setDesktopOnlyModalOpen = ref5[1];
    var isMobile = (0,useIsMobile/* default */.Z)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var onError = (0,useChannelError/* default */.Z)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useIncrementShareCountMutation */.cC4)({}), 1), incrementShareCountMutate = ref6[0];
    var incrementShareCountWithPlatform = function(platform) {
        if (!data.id) return;
        incrementShareCountMutate({
            variables: {
                newsItemId: data.id,
                platform: platform
            }
        });
    };
    var newsItemUrl = (0,react.useMemo)(function() {
        var ref;
        if (false) {}
        return "".concat(window.location.origin, "/channel/").concat((ref = data.channel) === null || ref === void 0 ? void 0 : ref.url, "/").concat(data.id);
    }, [
        data
    ]);
    var handleCopyMenuClick = function() {
        if (onError()) return;
        navigator.clipboard.writeText(newsItemUrl);
        incrementShareCountWithPlatform(graphql/* SharePlatFormType.URL */.zwq.URL);
        enqueueSnackbar("복사완료");
    };
    var menus = (0,react.useMemo)(function() {
        var menus = [];
        // 주소 복사
        menus.push({
            label: "주소 복사",
            handleClick: handleCopyMenuClick
        });
        // 신고
        if (!data.viewerIsAuthor) {
            menus.push({
                label: "소식 신고",
                handleClick: function() {
                    var ref;
                    if (onError()) return;
                    if (!((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) return setLoginModalOpen(true);
                    setReportModalOpen(true);
                }
            });
        }
        // 수정
        if (data.viewerIsAuthor) {
            menus.push({
                label: "소식 수정",
                handleClick: function() {
                    if (onError()) return;
                    if (isMobile) setDesktopOnlyModalOpen(true);
                    else setModifyModalOpen(true);
                }
            });
        }
        // 삭제
        if (data.viewerCanDelete) {
            menus.push({
                label: "소식 삭제",
                handleClick: function() {
                    if (onError()) return;
                    setDeleteNewsItemModalOpen(true);
                }
            });
        }
        return menus;
    }, [
        data,
        currentUserQuery.data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownBtn_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: menuRef,
                onClick: handleDropDownBtn,
                "data-open": isDropdownOpened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreDropdownBtn/* default */.Z, {
                    className: "more-menu-btn"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "more-menu-list",
                "data-open": isDropdownOpened,
                children: menus.map(function(menu, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "more-menu",
                        onClick: menu.handleClick,
                        children: menu.label
                    }, idx);
                })
            }),
            data.viewerHasReported && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlreadyReportedModal/* default */.Z, {
                type: "newsItem",
                open: reportModalOpen,
                onClose: function() {
                    return setReportModalOpen(false);
                }
            }),
            !data.viewerHasReported && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal/* default */.Z, {
                type: "newsItem",
                open: reportModalOpen,
                reportedId: data.id,
                onClose: function() {
                    return setReportModalOpen(false);
                }
            }),
            modifyModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_NewsItemModifyModal, {
                newsItemId: data.id,
                onClose: function() {
                    return setModifyModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_DeleteNewsItemModal, {
                open: deleteNewsItemModalOpen,
                newsItemId: data.id,
                onClose: function() {
                    return setDeleteNewsItemModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpen
                },
                onRequestClose: function() {
                    return setLoginModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopOnlyModal/* default */.Z, {
                open: desktopOnlyModalOpen,
                onClose: function() {
                    return setDesktopOnlyModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var NewsItemHeader_DropdownBtn = (DropdownBtn);
var DropdownBtn_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropdownBtn__StyledWrapper",
    componentId: "sc-b1a8f489-0"
})(DropdownBtn_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/NewsItemHeader.tsx


function NewsItemHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemHeader_NewsItem on NewsItem {\n    id\n    viewerIsAuthor\n    viewerHasReported\n    viewerCanDelete\n    createdAt\n    updatedAt\n    deletedAt\n    isNotice\n    channel {\n      id\n      url\n      name\n      viewerIsOwner\n      viewerHasFollowed\n      owner {\n        id\n        logoImage {\n          id\n          url\n        }\n      }\n    }\n  }\n"
    ]);
    NewsItemHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsItemHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 20px 12px;\n  .lt {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 1;\n    overflow: hidden;\n    .content {\n      overflow: hidden;\n      .channel-name {\n        display: block;\n        font-size: 16px;\n        font-weight: bold;\n        padding-bottom: 2px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .channel-info {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        .noticeBadge {\n          color: #479ef8;\n          background-color: #fff;\n          border: 1px solid #479ef8;\n          border-radius: 5px;\n          padding: 2px 5px 1px;\n          font-weight: 700;\n          font-size: 12px;\n        }\n        .type {\n          font-size: 14px;\n          padding: 1px 4px;\n        }\n        .date {\n          font-size: 14px;\n          color: #9f9f9f;\n        }\n      }\n    }\n  }\n  .rt {\n    flex-grow: 1;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .user-img {\n    border-radius: 50%;\n    overflow: hidden;\n    width: 40px;\n    height: 40px;\n    margin-right: 12px;\n  }\n  .more-btn-wrapper {\n    position: relative;\n    .more-menu-btn {\n      .dot {\n        background-color: #999999;\n      }\n    }\n    .more-menu-list {\n      display: none;\n      position: absolute;\n      top: calc(100% + 5px);\n      right: 0;\n      border: 1px solid #cccccc;\n      box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16);\n      border-radius: 5px;\n      padding: 6px 0;\n      text-align: center;\n      white-space: nowrap;\n      font-size: 12px;\n      background-color: white;\n      .more-menu {\n        display: block;\n        padding: 4px 12px;\n        &:hover {\n          background-color: #f8f8f8;\n        }\n      }\n      &[data-open='true'] {\n        display: block;\n      }\n    }\n  }\n  &[data-type='modal'] {\n    .lt {\n      .channel-info {\n        .date {\n          font-size: 12px;\n        }\n      }\n    }\n    .rt {\n      flex-shrink: 0;\n      align-self: stretch;\n    }\n  }\n  &[data-type='card'] {\n    .lt {\n      .channel-name {\n        font-size: 14px;\n      }\n      .channel-info {\n        .date {\n          font-size: 12px;\n        }\n      }\n    }\n    .rt {\n      flex-shrink: 0;\n      align-self: stretch;\n    }\n  }\n  ",
        " {\n    padding: 20px 20px 5px;\n    &[data-type='card'] {\n      padding: 15px 15px 5px;\n    }\n    &[data-type='modal'] {\n      padding: 0 20px 5px;\n      .lt {\n        .channel-name {\n          color: white;\n        }\n      }\n      .rt {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    NewsItemHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



















src_default()(NewsItemHeader_templateObject());
var NewsItemHeader = function(param) {
    var _type = param.type, type = _type === void 0 ? "feed" : _type, data = param.data, className = param.className, showFollowBtn = param.showFollowBtn;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var onError = (0,useChannelError/* default */.Z)();
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var followChannelMutation = (0,graphql/* useFollowChannelMutation */.R7_)({
        onError: onError
    });
    var ref12 = (0,react.useState)(false), loginModalOpened = ref12[0], setLoginModalOpened = ref12[1];
    var ref13 = (0,react.useState)(false), unFollowModalOpened = ref13[0], setUnFollowModalOpened = ref13[1];
    var handleFollowBtn = function() {
        var ref, ref1, ref2;
        if (!((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) return setLoginModalOpened(true);
        if (((ref1 = data.channel) === null || ref1 === void 0 ? void 0 : ref1.viewerHasFollowed) === undefined && !((ref2 = data.channel) === null || ref2 === void 0 ? void 0 : ref2.id)) return;
        if (!data.channel.viewerHasFollowed) {
            var _followChannelMutation = (0,_sliced_to_array/* default */.Z)(followChannelMutation, 1), mutate = _followChannelMutation[0];
            mutate({
                variables: {
                    channelId: data.channel.id
                },
                refetchQueries: [
                    {
                        query: graphql/* GqlFollowingsDocument */.nr9,
                        variables: {
                            Pagination: {
                                page: 1,
                                pageSize: 10
                            }
                        }
                    }, 
                ]
            });
        }
        if (data.channel.viewerHasFollowed) {
            setUnFollowModalOpened(true);
        }
    };
    var getSize = function() {
        if (!isMobile) {
            return type === "modal" ? 40 : 50;
        }
        if (isMobile) {
            return type === "feed" || type === "modal" ? 40 : 35;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItemHeader_StyledWrapper, {
            className: className,
            "data-type": type,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lt",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            type: "channel",
                            src: (ref = data.channel) === null || ref === void 0 ? void 0 : (ref1 = ref.owner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.logoImage) === null || ref2 === void 0 ? void 0 : ref2.url,
                            href: (0,util/* getWebviewHref */.ys)("/channel/".concat((ref3 = data.channel) === null || ref3 === void 0 ? void 0 : ref3.url), isWebview),
                            size: getSize()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,util/* getWebviewHref */.ys)("/channel/".concat((ref4 = data.channel) === null || ref4 === void 0 ? void 0 : ref4.url), isWebview),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "channel-name",
                                        children: (ref5 = data.channel) === null || ref5 === void 0 ? void 0 : ref5.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "channel-info",
                                    children: [
                                        data.isNotice && router.query["channel-url"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "noticeBadge",
                                            children: "공지"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "date",
                                            children: [
                                                (0,time/* convertCreatedAtToString */.Ui)(data.createdAt),
                                                data.updatedAt && " (수정됨)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "rt",
                    children: [
                        showFollowBtn && !((ref6 = data.channel) === null || ref6 === void 0 ? void 0 : ref6.viewerIsOwner) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "rt follow-btn",
                            variant: ((ref7 = data.channel) === null || ref7 === void 0 ? void 0 : ref7.viewerHasFollowed) ? "contained" : "outlined",
                            onClick: handleFollowBtn,
                            color: ((ref8 = data.channel) === null || ref8 === void 0 ? void 0 : ref8.viewerHasFollowed) ? "lightGrey2" : "primary",
                            disabled: (ref9 = data.channel) === null || ref9 === void 0 ? void 0 : ref9.viewerHasFollowed,
                            children: ((ref10 = data.channel) === null || ref10 === void 0 ? void 0 : ref10.viewerHasFollowed) ? "팔로우중" : "+팔로우"
                        }),
                        type !== "modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemHeader_DropdownBtn, {
                            data: data
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                    DialogProps: {
                        open: loginModalOpened
                    },
                    onRequestClose: function() {
                        return setLoginModalOpened(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnFollowModal/* default */.Z, {
                    open: unFollowModalOpened,
                    channelId: ((ref11 = data.channel) === null || ref11 === void 0 ? void 0 : ref11.id) || "",
                    onClose: function() {
                        return setUnFollowModalOpened(false);
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var NewsItemHeader_NewsItemHeader = (NewsItemHeader);
var NewsItemHeader_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemHeader__StyledWrapper",
    componentId: "sc-5294521a-0"
})(NewsItemHeader_templateObject1(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 4411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ NewsItemHeader_NewsItemHeaderLoading; },
  "Z": function() { return /* binding */ component_NewsItemHeader; }
});

// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/NewsItemHeader.tsx + 4 modules
var NewsItemHeader = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/NewsItemHeaderLoading.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-radius: 5px;\n        background-color: #eeeeee;\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 20px 12px;\n  .lt {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    .cover-image-box {\n      ",
        "\n    }\n    .content {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n    }\n    .channel-name {\n      height: 16px;\n      border-radius: 5px;\n      background-color: #eee;\n      width: 150px;\n      margin-bottom: 2px;\n    }\n    .channel-info {\n      height: 14px;\n      border-radius: 5px;\n      background-color: #eee;\n      width: 100px;\n    }\n  }\n  .rt {\n    height: 25px;\n    border-radius: 5px;\n    background-color: #eee;\n    width: 25px;\n    margin-bottom: 2px;\n  }\n\n  &[data-type='modal'] {\n    .rt {\n      flex-shrink: 0;\n      align-self: stretch;\n    }\n  }\n  &[data-type='card'] {\n    .rt {\n      flex-shrink: 0;\n      align-self: stretch;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var NewsItemHeaderLoading = function(param) {
    var type = param.type, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            className: className,
            "data-type": type,
            size: type === "modal" ? 40 : 50,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lt",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cover-image-box"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "channel-name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "channel-info"
                                })
                            ]
                        })
                    ]
                }),
                (type === "feed" || type === "card") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rt"
                })
            ]
        })
    });
};
/* harmony default export */ var NewsItemHeader_NewsItemHeaderLoading = (NewsItemHeaderLoading);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemHeaderLoading__StyledWrapper",
    componentId: "sc-523575c2-0"
})(_templateObject1(), function(param) {
    var size = param.size;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), size, size);
});

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/index.tsx



/* harmony default export */ var component_NewsItemHeader = (NewsItemHeader/* default */.Z);


/***/ }),

/***/ 56956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ component_NewsItemImageSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(51384);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
;// CONCATENATED MODULE: ./src/svgIcons/NewsSliderArrowLeft.tsx

var NewsSliderArrowLeft = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        "aria-label": "소식 슬라이더 왼쪽 화살표",
        display: props.isShow ? "block" : "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "소식 슬라이더 왼쪽 화살표"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "9mt3a8t7xa",
                    width: "44",
                    height: "44",
                    x: "0",
                    y: "0",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0.161"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "data-name": "그룹 11003",
                        filter: "url(#9mt3a8t7xa)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "16",
                            cy: "16",
                            r: "16",
                            fill: "#fff",
                            "data-name": "타원 1028",
                            transform: "translate(6 4)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        stroke: "#333",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.5",
                        d: "M24.506 13.924L17.498 20l7.008 6.076",
                        "data-name": "패스 7992"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var svgIcons_NewsSliderArrowLeft = (NewsSliderArrowLeft);

;// CONCATENATED MODULE: ./src/svgIcons/NewsSliderArrowRight.tsx

var NewsSliderArrowRight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        "aria-label": "소식 슬라이더 오른쪽 화살표",
        display: props.isShow ? "block" : "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "소식 슬라이더 오른쪽 화살표"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "679do00p5a",
                    width: "44",
                    height: "44",
                    x: "0",
                    y: "0",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            result: "blur",
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0.161"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "blur",
                            operator: "in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in: "SourceGraphic"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "data-name": "그룹 11003",
                        filter: "url(#679do00p5a)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "16",
                            cy: "16",
                            r: "16",
                            fill: "#fff",
                            "data-name": "타원 1028",
                            transform: "rotate(180 19 18)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        stroke: "#333",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.5",
                        d: "M19.495 26.075l7.008-6.076-7.008-6.076",
                        "data-name": "패스 7992"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var svgIcons_NewsSliderArrowRight = (NewsSliderArrowRight);

// EXTERNAL MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(26126);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemImageZoom.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  .tools {\n    position: absolute;\n    top: 24px;\n    right: ",
        ";\n    z-index: 1;\n    button {\n      color: #fff;\n      background-color: rgba(51, 51, 51, 0.55);\n      font-size: 12px;\n      height: 40px;\n      padding: 0 10px;\n      border: none;\n      border-radius: 3px;\n      margin-left: 8px;\n      cursor: pointer;\n      img {\n        width: 20px;\n      }\n    }\n    .btn-disabled {\n      opacity: 0.4;\n    }\n  }\n\n  .transform-wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  .content-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n\n  .image {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    aspect-ratio: 1 / 1;\n    object-position: center;\n  }\n\n  ",
        " {\n    .tools {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var NewsItemImageZoom = function(param) {
    var imageUrl = param.imageUrl, isMulti = param.isMulti;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        isMulti: isMulti,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, {
            wheel: {
                disabled: true
            },
            minScale: 1,
            maxScale: 5,
            children: function(param) {
                var zoomIn = param.zoomIn, zoomOut = param.zoomOut, state = param.state;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tools",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return zoomIn();
                                    },
                                    className: "".concat(state.scale === 5 && "btn-disabled"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/static/images/new_main/icon/btn_enlargement.png",
                                        alt: "확대"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return zoomOut();
                                    },
                                    className: "".concat(state.scale === 1 && "btn-disabled"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/static/images/new_main/icon/btn_reduction.png",
                                        alt: "축소"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                            wrapperClass: "transform-wrapper",
                            contentClass: "content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "image",
                                src: imageUrl,
                                alt: "기업채널 소식"
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var component_NewsItemImageZoom = (NewsItemImageZoom);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemImageZoom__StyledWrapper",
    componentId: "sc-15db7ed7-0"
})(_templateObject(), function(param) {
    var isMulti = param.isMulti;
    return isMulti ? "98px" : "20px";
}, media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemImageSlider.tsx

function NewsItemImageSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItemImageSlider_Attachment on Attachment {\n    id\n    url\n  }\n"
    ]);
    NewsItemImageSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n\n  .swiper-container {\n    z-index: 0;\n    overflow: visible;\n  }\n\n  .swiper-pagination {\n    bottom: -25px;\n    margin-left: 0;\n  }\n\n  .swiper-pagination-bullet,\n  .swiper-pagination-bullet-active {\n    width: 10px;\n    height: 10px;\n    opacity: 1;\n    background-color: #dddddd;\n    margin: 0px 10px;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: #5ea9ff;\n  }\n  .count {\n    position: absolute;\n    top: 24px;\n    right: 20px;\n    height: 40px;\n    z-index: 1;\n    padding: 0 15px;\n    border-radius: 3px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.43;\n    letter-spacing: -0.56px;\n    color: #fff;\n    background-color: rgba(51, 51, 51, 0.55);\n    display: flex;\n    align-items: center;\n  }\n\n  .left-btn {\n    left: 24px;\n  }\n\n  .right-btn {\n    right: 24px;\n  }\n  .right-btn,\n  .left-btn {\n    cursor: pointer;\n    border: none;\n    background: none;\n    padding: 0px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n\n  .img-wrapper {\n    position: relative;\n    width: 100%;\n    background-color: #333;\n    &:after {\n      content: '';\n      display: block;\n      padding-bottom: 100%;\n    }\n    .img {\n      position: absolute;\n      width: 100%;\n      height: auto;\n      object-fit: cover;\n      aspect-ratio: 1 / 1;\n      object-position: center;\n    }\n  }\n  &[data-type='card'] {\n    .img-wrapper {\n      position: relative;\n      background-color: #333;\n      cursor: default;\n      &:after {\n        display: none;\n      }\n      .img {\n        position: relative;\n        height: 255px;\n      }\n    }\n  }\n  &[data-type='modal'] {\n    .img-wrapper {\n      cursor: default;\n    }\n  }\n\n  &[data-img='multi'] {\n    padding-bottom: 30px;\n    &[data-type='card'] {\n      padding-bottom: 0;\n    }\n  }\n\n  ",
        " {\n    &[data-type='card'] {\n      .img-wrapper {\n        .img {\n          height: 200px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(NewsItemImageSlider_templateObject());
// todo : 슬라이드 개수, 슬라이드 버튼 기능 구현
var NewsItemImageSlider = function(param) {
    var data = param.data, type = param.type, onClick = param.onClick, className = param.className;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,react.useState)(0), sliderCount = ref[0], setSliderCount = ref[1];
    var sliderRef = (0,react.useRef)(null);
    var pagination = {
        clickable: true,
        renderBullet: function(_, className) {
            return "<span class=".concat(className, "></span>");
        }
    };
    var prevButtonRef = (0,react.useRef)(null);
    var nextButtonRef = (0,react.useRef)(null);
    var swiperInit = function(swiper) {
        var navigation = swiper.params.navigation;
        if (typeof navigation !== "boolean" && navigation) {
            navigation.prevEl = prevButtonRef.current;
            navigation.nextEl = nextButtonRef.current;
        }
        swiper.navigation.init();
        swiper.navigation.update();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItemImageSlider_StyledWrapper, {
        className: className,
        "data-type": type,
        "data-img": data.length > 1 ? "multi" : "",
        children: [
            data.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "count",
                        children: [
                            sliderCount + 1,
                            "/",
                            data.length
                        ]
                    }),
                    type !== "card" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "left-btn",
                                ref: prevButtonRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_NewsSliderArrowLeft, {
                                    isShow: sliderCount !== 0
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "right-btn",
                                ref: nextButtonRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_NewsSliderArrowRight, {
                                    isShow: sliderCount !== data.length - 1
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                ref: sliderRef,
                onSlideChange: function(swiper) {
                    return setSliderCount(swiper.activeIndex);
                },
                touchRatio: isMobile ? 1 : 0,
                pagination: pagination,
                className: "swiper-container",
                modules: [
                    swiper_esm/* Pagination */.tl,
                    swiper_esm/* Navigation */.W_
                ],
                onInit: swiperInit,
                children: data.map(function(image, idx) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "img-wrapper",
                        onClick: onClick,
                        children: type === "modal" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(component_NewsItemImageZoom, {
                            imageUrl: image === null || image === void 0 ? void 0 : image.url,
                            isMulti: data.length > 1
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "img",
                            src: image === null || image === void 0 ? void 0 : image.url,
                            alt: "기업채널 소식"
                        })
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var component_NewsItemImageSlider = (NewsItemImageSlider);
var NewsItemImageSlider_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsItemImageSlider__StyledWrapper",
    componentId: "sc-7e876af0-0"
})(_templateObject1(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 88916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67235);
/* harmony import */ var _app_modules_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65677);





var useTagEffect = function(ref) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var _$ref;
        var tags = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getElementsByClassName("ql-hashtag");
        if (!tags) return;
        var onTagClick = function(tagElementEvent) {
            var targetSpan = tagElementEvent.target;
            var tagKeyword = encodeURIComponent(targetSpan.innerText || "").replace(/%EF%BB%BF/g, "");
            var query = [
                "q=".concat(tagKeyword)
            ];
            if (isWebview) {
                var backHref = router.query.back ? router.query.back : router.asPath;
                var backKeyword = encodeURIComponent("".concat(backHref || "")).replace(/%EF%BB%BF/g, "");
                query.push("back=".concat(backKeyword));
            }
            var url = (0,_app_modules_util__WEBPACK_IMPORTED_MODULE_3__/* .getWebviewHref */ .ys)("/channel/search?".concat(query.join("&")), isWebview);
            router.push(url);
        };
        for(var i = 0; i < tags.length; i++){
            tags[i].addEventListener("click", onTagClick);
        }
        return function() {
            for(var i = 0; i < tags.length; i++){
                tags[i].removeEventListener("click", onTagClick);
            }
        };
    }, [
        router,
        ref,
        isWebview,
        router.query.back,
        router.asPath
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useTagEffect);


/***/ }),

/***/ 24744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68250);
/* harmony import */ var _component_NewsItemContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46030);
/* harmony import */ var _component_NewsItemHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4411);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: white;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  & > .hr {\n    height: 1px;\n    background-color: #e8e8e8;\n    margin-bottom: 20px;\n  }\n  ",
        " {\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






// todo: footer skeleton 없음.
var ScreenNewsItemFeedLoading = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_component_NewsItemHeader__WEBPACK_IMPORTED_MODULE_5__/* .NewsItemHeaderLoading */ .j, {
                type: "feed"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_component_NewsItemContent__WEBPACK_IMPORTED_MODULE_4__/* .NewsItemContentLoading */ .F, {
                type: "feed"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScreenNewsItemFeedLoading);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ScreenNewsItemFeedLoading__StyledWrapper",
    componentId: "sc-cdd1a4c-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_3__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 18567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ScreenNewsItemModal_ScreenNewsItemModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./node_modules/interweave-autolink/esm/index.js
var interweave_autolink_esm = __webpack_require__(41366);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.feature/channel/module/getChannelOgData.ts
var getChannelOgData = __webpack_require__(79480);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentForm/NewsItemCommentForm.tsx + 2 modules
var NewsItemCommentForm = __webpack_require__(33890);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/index.tsx + 10 modules
var NewsItemCommentList = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemFooter/NewsItemFooter.tsx + 9 modules
var NewsItemFooter = __webpack_require__(53505);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/NewsItemHeader.tsx + 4 modules
var NewsItemHeader = __webpack_require__(71387);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemImageSlider.tsx + 3 modules
var NewsItemImageSlider = __webpack_require__(56956);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/hook/useTagEffect.ts
var useTagEffect = __webpack_require__(88916);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemModal/ScreenNewsItemModal.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: transparent;\n  border-radius: 10px;\n  & > .lt {\n    width: 800px;\n    height: 800px;\n    background-color: #333;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    overflow: hidden;\n  }\n  & > .rt {\n    position: relative;\n    width: 420px;\n    height: 800px;\n    background-color: white;\n    overflow: visible;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 10px;\n    .close-btn {\n      color: white;\n      cursor: pointer;\n      position: absolute;\n      top: 0;\n      right: 0;\n      transform: translate(150%, -100%);\n    }\n    .modal-content {\n      width: 100%;\n      flex-grow: 1;\n      overflow-y: scroll;\n      & > .description {\n        padding: 0 20px 20px;\n        min-height: 100px;\n        a {\n          color: rgb(1, 160, 255) !important;\n        }\n      }\n    }\n    .form {\n      padding: 0 20px;\n    }\n  }\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var ScreenNewsItemModalDesktop = function(param) {
    var data = param.data, onClose = param.onClose, className = param.className;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var descriptionRef = (0,react.useRef)(null);
    (0,useTagEffect/* default */.Z)(descriptionRef);
    var ogData = (0,getChannelOgData/* default */.Z)({
        data: data
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lt",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemImageSlider/* default */.Z, {
                    data: ((ref = data.content) === null || ref === void 0 ? void 0 : ref.images.nodes) || [],
                    type: "modal"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "rt",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-btn",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemHeader/* default */.Z, {
                        data: data.header,
                        type: "modal",
                        showFollowBtn: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                ref: descriptionRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Interweave */.wZ, {
                                    content: (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.content,
                                    matchers: [
                                        new interweave_autolink_esm/* UrlMatcher */.xc("url")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentList/* default */.ZP, {
                                type: "modal",
                                expendComment: true,
                                newsItemId: ((ref2 = data.commentList) === null || ref2 === void 0 ? void 0 : ref2.id) || "",
                                viewerIsAuthor: ((ref3 = data.commentList) === null || ref3 === void 0 ? void 0 : ref3.viewerIsAuthor) || false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemFooter/* default */.Z, {
                        type: "modal",
                        data: data.footer,
                        ogData: ogData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentForm/* default */.Z, {
                            expendComment: true,
                            newsItemId: ((ref4 = data.commentForm) === null || ref4 === void 0 ? void 0 : ref4.id) || "",
                            viewerCanReply: ((ref5 = data.commentForm) === null || ref5 === void 0 ? void 0 : ref5.viewerCanReply) || false
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenNewsItemModal_desktop = (ScreenNewsItemModalDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNewsItemModal.desktop__StyledWrapper",
    componentId: "sc-33641b78-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/index.tsx + 1 modules
var NewsItemContent = __webpack_require__(46030);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemModal/ScreenNewsItemModal.mobile.tsx

function ScreenNewsItemModal_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #333;\n  flex-direction: column;\n  justify-content: space-between;\n  .close-btn {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    color: white;\n    cursor: pointer;\n    padding: 20px 20px 0;\n    svg {\n      fill: #fff;\n      width: 16px;\n      height: 16px;\n    }\n  }\n  .top {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    height: 100%;\n  }\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    ScreenNewsItemModal_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ScreenNewsItemModalMobile = function(param) {
    var data = param.data, onClose = param.onClose, className = param.className;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var handleCommentBtnClick = function() {
        if (isMobile) {
            var ref, ref1, ref2;
            if (router.pathname === (0,util/* getWebviewHref */.ys)("/channel/[channel-url]/[news-id]", isWebview)) {
                onClose && onClose();
            } else router.push((0,util/* getWebviewHref */.ys)("/channel/".concat((ref = data.header) === null || ref === void 0 ? void 0 : (ref1 = ref.channel) === null || ref1 === void 0 ? void 0 : ref1.url, "/").concat((ref2 = data.header) === null || ref2 === void 0 ? void 0 : ref2.id), isWebview));
        }
    };
    var ogData = (0,getChannelOgData/* default */.Z)({
        data: data
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenNewsItemModal_mobile_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-btn",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemHeader/* default */.Z, {
                        data: data.header,
                        type: "modal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemContent/* default */.Z, {
                        type: "modal",
                        data: data.content
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemFooter/* default */.Z, {
                type: "modal",
                data: data.footer,
                onCommentBtnClick: handleCommentBtnClick,
                ogData: ogData
            })
        ]
    });
};
/* harmony default export */ var ScreenNewsItemModal_mobile = (ScreenNewsItemModalMobile);
var ScreenNewsItemModal_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNewsItemModal.mobile__StyledWrapper",
    componentId: "sc-491a301a-0"
})(ScreenNewsItemModal_mobile_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemModal/ScreenNewsItemModal.tsx








var ScreenNewsItemModal = function(_param) {
    var data = _param.data, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onClose"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClose: onClose
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemModal_desktop, {
                data: data,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemModal_mobile, {
                data: data,
                onClose: onClose
            })
        ]
    }));
};
/* harmony default export */ var ScreenNewsItemModal_ScreenNewsItemModal = (ScreenNewsItemModal);


/***/ }),

/***/ 61996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  .dot {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background-color: #ccc;\n  }\n  &:hover {\n    background-color: #f5f5f5;\n  }\n  &[data-open='true'] {\n    background-color: #f5f5f5;\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MoreDropdownBtn = function(_param) {
    var className = _param.className, _direction = _param.direction, direction = _direction === void 0 ? "col" : _direction, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "direction"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        direction: direction
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "dot"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreDropdownBtn);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreDropdownBtn__StyledWrapper",
    componentId: "sc-67668b78-0"
})(_templateObject1(), function(param) {
    var direction = param.direction;
    return direction === "row" && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 27662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  .lt {\n    display: flex;\n    gap: 10px;\n    .img-box {\n      width: 43px;\n      height: 43px;\n      background-color: #eee;\n      border-radius: 5px;\n    }\n    .lt-content {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      .follow-card-title {\n        height: 16px;\n        width: 70px;\n        background-color: #eee;\n        border-radius: 5px;\n        margin-bottom: 3px;\n      }\n      .follow-card-subtitle {\n        height: 12px;\n        width: 80px;\n        background-color: #eee;\n        border-radius: 5px;\n      }\n    }\n  }\n  .btn {\n    height: 34px;\n    width: 70px;\n    background-color: #eee;\n    border-radius: 5px;\n    margin-bottom: 3px;\n  }\n  &[data-type='search'] {\n    padding: 20px 0;\n    .lt {\n      gap: 24px;\n      .img-box {\n        width: 66px;\n        height: 66px;\n      }\n      .content-box-subtitle {\n        color: #333;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ChannelCardLoading = function(param) {
    var _type = param.type, type = _type === void 0 ? "home" : _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "lt",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "img-box"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "lt-content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "follow-card-title"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "follow-card-subtitle"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "btn"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChannelCardLoading);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ChannelCardLoading__StyledWrapper",
    componentId: "sc-51686026-0"
})(_templateObject());


/***/ }),

/***/ 79127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85025);
/* harmony import */ var app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7029);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68250);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 360px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-sub-title {\n    font-size: 20px;\n    margin: 20px 0 30px;\n    width: 100%;\n    text-align: center;\n    font-weight: 500;\n  }\n  .btn {\n    font-size: 16px;\n    padding: 13px 34px;\n    margin-bottom: 20px;\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AlreadyReportedModal = function(_param) {
    var onClose = _param.onClose, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "onClose",
        "type"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .Close */ .x8, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "modal-sub-title",
                    children: [
                        "이미 신고한 ",
                        type === "comment" ? "댓글" : "소식",
                        "입니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "btn",
                    onClick: onClose,
                    children: "확인"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AlreadyReportedModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AlreadyReportedModal__StyledWrapper",
    componentId: "sc-78962ca3-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_6__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 62609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85025);
/* harmony import */ var app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7029);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68250);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 450px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-sub-title {\n    font-size: 18px;\n    margin: 20px 0 30px;\n    width: 100%;\n    text-align: center;\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DesktopOnlyModal = function(_param) {
    var onClose = _param.onClose, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "onClose"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .Close */ .x8, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "modal-sub-title",
                    children: [
                        "PC에서만 이용 가능한 기능입니다.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "PC에서 이용해주세요."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "btn-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: "btn",
                        onClick: onClose,
                        children: "확인"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DesktopOnlyModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "DesktopOnlyModal__StyledWrapper",
    componentId: "sc-9c952724-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_6__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 44575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export REPORT_REASONS */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29496);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53893);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85025);
/* harmony import */ var _app_feature_channel_hook_useChannelError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65982);
/* harmony import */ var app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7029);
/* harmony import */ var app_components_inputs_Radio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67779);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68250);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 450px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-header {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #eeeeee;\n    .header-title {\n      font-size: 18px;\n      font-weight: 500;\n    }\n  }\n  .modal-title {\n    font-size: 24px;\n    font-weight: 600;\n  }\n  .modal-sub-title {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    font-size: 18px;\n    margin: 20px 0 30px;\n    width: 100%;\n    font-weight: 500;\n  }\n  .modal-description {\n    font-size: 16px;\n    margin: 20px 0 30px;\n    text-align: center;\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var REPORT_REASONS = {
    ABUSIVE_WORD: "욕설/비하 발언",
    OBSCENE_POST: "음란성",
    PROMOTIONAL_CONTENT: "홍보성 콘텐츠 및 도배글",
    PERSONAL_INFO_EXPOSURE: "개인정보 노출",
    SLANDER: "특정인 비방",
    ETC: "기타"
};
var ReportModal = function(_param) {
    var reportedId = _param.reportedId, onClose = _param.onClose, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "reportedId",
        "onClose",
        "type"
    ]);
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_3__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var onError = (0,_app_feature_channel_hook_useChannelError__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var reportNewsItemMutate = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlReportNewsItemMutation */ .haV)({
        onCompleted: function() {
            enqueueSnackbar("신고 완료되었습니다.");
        },
        onError: onError
    });
    var reportNewsCommentMutation = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useReportNewsCommentMutation */ .hpV)({
        onCompleted: function() {
            enqueueSnackbar("신고 완료되었습니다.");
        },
        onError: onError
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(REPORT_REASONS.ABUSIVE_WORD), input = ref[0], setInput = ref[1];
    var handleConfirm = function() {
        if (type === "newsItem") {
            var _reportNewsItemMutate = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(reportNewsItemMutate, 1), mutate = _reportNewsItemMutate[0];
            mutate({
                variables: {
                    input: {
                        reportedId: reportedId,
                        reason: "".concat(input)
                    }
                }
            });
        }
        if (type === "comment") {
            var _reportNewsCommentMutation = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(reportNewsCommentMutation, 1), mutate1 = _reportNewsCommentMutation[0];
            mutate1({
                variables: {
                    input: {
                        reportedId: reportedId,
                        reason: "".concat(input)
                    }
                }
            });
        }
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "header-title",
                            children: [
                                type === "comment" ? "댓글" : "소식",
                                " 신고 사유를 선택해주세요."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "close-btn",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "modal-sub-title",
                    children: Object.values(REPORT_REASONS).map(function(reason) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_inputs_Radio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            defaultChecked: reason === REPORT_REASONS.ABUSIVE_WORD,
                            labelText: reason,
                            labelFor: reason,
                            id: reason,
                            value: reason,
                            onClick: function() {
                                return setInput(reason);
                            },
                            name: "ban-reason"
                        }, reason);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "btn",
                            onClick: handleConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ReportModal__StyledWrapper",
    componentId: "sc-eb102539-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_10__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 24388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47079);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85025);
/* harmony import */ var app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7029);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68250);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 450px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-title {\n    font-size: 24px;\n    font-weight: 600;\n  }\n  .modal-description {\n    font-size: 16px;\n    margin: 20px 0 30px;\n    text-align: center;\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    .btn {\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n  ",
        " {\n    max-width: 350px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var UnFollowModal = function(_param) {
    var channelId = _param.channelId, onClose = _param.onClose, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "channelId",
        "onClose"
    ]);
    var unfollowChannelMutation = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useUnfollowChannelMutation */ .feu)();
    var handleClickConfirm = function() {
        var _unfollowChannelMutation = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(unfollowChannelMutation, 1), mutate = _unfollowChannelMutation[0];
        mutate({
            variables: {
                channelId: channelId
            },
            refetchQueries: [
                {
                    query: generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .GqlFollowingsDocument */ .nr9,
                    variables: {
                        Pagination: {
                            page: 1,
                            pageSize: 10
                        }
                    }
                }, 
            ]
        });
        onClose && onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            className: "common-modal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .Close */ .x8, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "modal-title",
                    children: "정말 취소하시겠어요?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "modal-description",
                    children: [
                        "팔로우를 취소하면 이 채널에 새로운 소식이나",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "공고가 등록될 시 알림을 받아 볼 수 없게 됩니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "취소"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: "btn",
                            onClick: handleClickConfirm,
                            children: "확인"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (UnFollowModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "UnFollowModal__StyledWrapper",
    componentId: "sc-5554b1d3-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_7__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 65982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var _app_components_modals_ChannelDeactivatedModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99078);
/* harmony import */ var components_customer_message_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6925);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96597);




var useChannelError = function() {
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().enqueueApolloError;
    var currentUserQuery = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUserQuery */ .rkO)();
    var openCustomerMessageForm = (0,components_customer_message_form__WEBPACK_IMPORTED_MODULE_2__/* .useOpenCustomerMessageForm */ .f)();
    var onError = function(error) {
        var ref, ref1, ref2;
        if ((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.channel) === null || ref2 === void 0 ? void 0 : ref2.deactivatedAt) {
            (0,_app_components_modals_ChannelDeactivatedModal__WEBPACK_IMPORTED_MODULE_1__/* .openChannelDeactivatedModal */ .$)({
                open: true,
                onConfirm: openCustomerMessageForm
            });
            return true;
        } else if (error) {
            enqueueApolloError(error);
            return !!error;
        }
    };
    return onError;
};
/* harmony default export */ __webpack_exports__["Z"] = (useChannelError);


/***/ }),

/***/ 14653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useExpendBtn = function() {
    var skip = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isExpended = ref[0], setIsExpended = ref[1];
    var targetRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (skip === true) {
            setIsExpended(true);
        } else if (targetRef.current) {
            setIsExpended(targetRef.current.scrollHeight <= targetRef.current.clientHeight);
        }
    }, [
        targetRef,
        skip
    ]);
    var handleClick = function() {
        setIsExpended(true);
    };
    var handleCancleClick = function() {
        setIsExpended(false);
    };
    return [
        isExpended,
        targetRef,
        handleClick,
        handleCancleClick
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useExpendBtn);


/***/ }),

/***/ 84108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23913);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ReadNewsItem($newsItemId: ID!) {\n    readNewsItem(newsItemId: $newsItemId) {\n      newsItem {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




graphql_tag__WEBPACK_IMPORTED_MODULE_2___default()(_templateObject());
var useReadNewsItemEffect = function(id) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRendered = ref[0], setIsRendered = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_3__/* .useReadNewsItemMutation */ .V0n)({
        onCompleted: function() {
            setIsRendered(true);
        }
    }), 1), mutate = ref1[0];
    var target = (0,_app_modules_hooks_useIntersect__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        if (!id || isRendered) return;
        mutate({
            variables: {
                newsItemId: id
            }
        });
    }, [
        isRendered
    ]);
    return target;
};
/* harmony default export */ __webpack_exports__["Z"] = (useReadNewsItemEffect);


/***/ }),

/***/ 79480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_metaData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77482);

var getChannelOgData = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3;
    var ogData = {
        title: "".concat((ref = data.header) === null || ref === void 0 ? void 0 : (ref1 = ref.channel) === null || ref1 === void 0 ? void 0 : ref1.name, " - 기업채널 | 링커리어") || 0,
        image: ((ref3 = (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2.images.nodes[0]) === null || ref3 === void 0 ? void 0 : ref3.url) || "https://linkareer.com/static/images/channel/channel-seo.png"
    };
    return ogData;
};
/* harmony default export */ __webpack_exports__["Z"] = (getChannelOgData);


/***/ }),

/***/ 6714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function assertIsNode(e) {
    if (!e || !("nodeType" in e)) {
        throw new Error("Node expected");
    }
}
var useDropdown = function() {
    var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDropdownOpened = ref[0], setIsDropdownOpened = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return function() {
            window.removeEventListener("click", handleClick);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    var handleClick = function(e) {
        if (!menuRef.current) return;
        assertIsNode(e.target);
        if (menuRef.current.contains(e.target) === false) {
            setIsDropdownOpened(false);
            window.removeEventListener("click", handleClick);
        }
    };
    var handleKeyDown = function(e) {
        if (!(e.key === "Enter") || !menuRef.current) return;
        assertIsNode(e.target);
        setIsDropdownOpened(false);
        window.removeEventListener("keydown", handleKeyDown);
        var targetInputName = e.target.name;
        var inputElement = document.querySelector('input[name="'.concat(targetInputName, '"]'));
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.blur();
    };
    var toggleDropdown = function() {
        setIsDropdownOpened(function(prev) {
            return !prev;
        });
        window.removeEventListener("click", handleClick);
        window.addEventListener("click", handleClick);
        window.removeEventListener("keydown", handleKeyDown);
        window.addEventListener("keydown", handleKeyDown);
    };
    return [
        menuRef,
        isDropdownOpened,
        toggleDropdown
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useDropdown);


/***/ }),

/***/ 23913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var useIntersect = function(handleIntersect) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var target = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer;
        if (target.current) {
            observer = new IntersectionObserver(_handleIntersect, {
                threshold: 1
            });
            observer.observe(target.current);
        }
        return function() {
            observer && observer.disconnect();
        };
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(deps));
    // TODO eslint 에러 원인 찾기
    // eslint-disable-next-line no-undef
    var _handleIntersect = function(param, observer) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), entry = _param[0];
        if (entry.isIntersecting) {
            handleIntersect(entry, observer);
        }
    };
    return target;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersect);


/***/ }),

/***/ 50516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68250);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27963);


var useIsMobile = function() {
    var matches = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("(max-width: ".concat(app_styled_media__WEBPACK_IMPORTED_MODULE_0__/* .mobileBreakPointSize */ .Zq, "px)"));
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 27963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * React hook to evaluate a CSS media query and return whether it matches.
 *
 * Usage example:
 *   const isDesktop = useMediaQuery('(min-width: 960px)')
 *
 * @param query - A valid CSS media query string
 *   e.g. '(min-width: 960px)', '(max-width: 600px)'
 *
 * @param defaultMatches - Initial match value used during SSR (server-side rendering).
 *   - SSR에서는 `window.matchMedia`를 사용할 수 없으므로 기본값을 사용합니다.
 *   - 기본값은 false이며, 필요하다면 UA 기반으로 true/false를 전달할 수 있습니다.
 *   - 예: `useMediaQuery('(min-width: 960px)', { defaultMatches: isDesktopUA })`
 *
 * ⚠️ 주의
 * - query에는 반드시 완전한 미디어 문자열(@media 없이)만 넣어야 합니다.
 *   예: "tabletBreakPoint" 같은 상수가 있다면, 실제 문자열 "(min-width: 960px)" 형태로 전달해야 합니다.
 * - defaultMatches는 선택값이며, SSR 환경에서 깜빡임(mismatch)을 줄이려면
 *   UA(user agent) 기반 값을 넘겨주는 것이 좋습니다.
 */ var useMediaQuery = function(query) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _defaultMatches = ref.defaultMatches, defaultMatches = _defaultMatches === void 0 ? false : _defaultMatches;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultMatches), matches = ref1[0], setMatches = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mql = window.matchMedia(query);
        var onChange = function() {
            setMatches(mql.matches);
        };
        onChange();
        if (mql.addEventListener) {
            mql.addEventListener("change", onChange);
        } else {
            // Safari < 14 fallback
            mql.addListener(onChange);
        }
        return function() {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", onChange);
            } else {
                mql.removeListener(onChange);
            }
        };
    }, [
        query
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 20178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ui": function() { return /* binding */ convertCreatedAtToString; },
/* harmony export */   "ax": function() { return /* binding */ formatRemainingTimeToString; }
/* harmony export */ });
/* unused harmony export getRemainingTime */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23311);
/* harmony import */ var date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76972);
/* harmony import */ var date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69690);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32912);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42699);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7069);
/* harmony import */ var date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81289);
/* harmony import */ var date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88619);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);










var convertCreatedAtToString = function(createdAt) {
    var NOW = new Date();
    var ONE_MINUTE_AGO = (0,date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NOW, 1);
    var ONE_HOUR_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 1);
    var ONE_DAY_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 24);
    var ONE_WEEK_AGO = (0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(NOW, 7);
    var writenInOneMunite = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_MINUTE_AGO);
    var writenInOneHour = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_HOUR_AGO);
    var writenInOneDay = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_DAY_AGO);
    var writenInOneWeek = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_WEEK_AGO);
    if (writenInOneMunite) {
        return "방금 전";
    }
    if (writenInOneHour) {
        return "".concat((0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(NOW, createdAt), "분 전");
    }
    if (writenInOneDay) {
        return "".concat((0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(NOW, createdAt), "시간 전");
    }
    if (writenInOneWeek) {
        return "".concat((0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(NOW, createdAt), "일 전");
    }
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(createdAt, "yyyy.MM.dd");
};
var getRemainingTime = function(date) {
    var nowDate = new Date();
    return (0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(date, nowDate.getTime());
};
var formatRemainingTimeToString = function(closedAt, recruitType) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "CoverLetterTitle", isOnlyDate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    switch(recruitType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ALWAYS */ .iS2.ALWAYS:
            return "상시채용";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ASAP */ .iS2.ASAP:
            return "채용 시 마감";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.SCHEDULED */ .iS2.SCHEDULED:
            return "예정";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.NORMAL */ .iS2.NORMAL:
            if (closedAt) {
                var dDay = getRemainingTime(closedAt);
                if (dDay === 0) {
                    var hours = (0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(closedAt, new Date());
                    if (hours === 0) {
                        var minutes = (0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(closedAt, new Date());
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            style: {
                                color: "#ff0000"
                            },
                            children: [
                                minutes,
                                "분 남음"
                            ]
                        });
                    }
                    if (hours < 0) {
                        if (type === "DutyItem") return "마감";
                        return "D+".concat(Math.abs(hours), "시");
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        style: {
                            color: "#ff0000"
                        },
                        children: [
                            hours,
                            "시간 남음"
                        ]
                    });
                }
                if (dDay < 0) {
                    if (type === "DutyItem") return "마감";
                    return "D+".concat(Math.abs(dDay) > 999 ? 999 : Math.abs(dDay)).concat(isOnlyDate ? "" : "일");
                }
                return "D-".concat(dDay > 999 ? 999 : dDay).concat(isOnlyDate ? "" : "일");
            }
            return "마감일 없음";
        default:
            return "마감일 없음";
    }
};


/***/ }),

/***/ 14609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);



var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        root: {
            display: "flex",
            gap: "10px",
            width: 110,
            height: 24,
            paddingTop: 12
        },
        ball: {
            width: 12,
            height: 12,
            display: "inline-block",
            float: "left",
            borderRadius: "50%",
            animation: "$delay 0.8s infinite ease-in-out",
            "&:nth-child(2)": {
                animationDelay: "-0.7s"
            },
            "&:nth-child(3)": {
                animationDelay: "-0.6s"
            },
            "&:nth-child(4)": {
                animationDelay: "-0.5s"
            },
            "&:nth-child(5)": {
                animationDelay: "-0.4s"
            }
        },
        "@keyframes delay": {
            "0%, 40%, 100%": {
                transform: "translateY(0)",
                backgroundColor: "#e1e1e1"
            },
            "20%": {
                transform: "translateY(-10px)",
                backgroundColor: "#888888"
            }
        }
    };
});
var BounceLoading = function(param) {
    var className = param.className;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.ball
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BounceLoading);


/***/ }),

/***/ 39749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17563);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75551);
/* harmony import */ var components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13133);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  & > b,\n  strong {\n    font-size: 18px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LoginAlert = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var goLogin = function() {
        var next = props.chatRoomId ? "".concat(window.location.href, "?").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE_QUERY_KEY */ .v, "=").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE.DEFAULT */ .X.DEFAULT, "&chatRoomId=").concat(props.chatRoomId) : window.location.href;
        router.push("/login?".concat(query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
            next: next
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                    children: "로그인 후 이용가능한 서비스입니다."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                    children: "로그인 하시겠습니까?"
                })
            ]
        }),
        onConfirm: goLogin,
        confirmLabel: "확인"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginAlert);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "LoginAlert__StyledWrapper",
    componentId: "sc-de340b2b-0"
})(_templateObject());


/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    INVALID_REQUEST: "올바르지 않은 요청 입니다.",
    NO_RESPONSE_ERROR: "현재 서버에 응답이 없습니다. 잠시후 다시 시도해주세요",
    UNKNOWN_ERROR: "알 수 없는 오류가 발생했습니다.",
    FORBIDDEN: "요청할 수 있는 권한이 없습니다.",
    UNAUTHENTICATED: "계정이 인증되지 않았습니다. 로그인 확인 후 다시 시도해 보세요.",
    REQUIRED_LOGGED_IN: "로그인 후 사용할 수 있습니다.",
    NOT_FOUND_ERROR: "알 수 없는 오류가 발생했습니다.",
    ALREADY_EXISTING_EMAIL: "이미 가입된 이메일 입니다. 다른 이메일을 사용해주세요",
    ALREADY_EXISTING_NICKNAME: "이미 가입된 닉네임 입니다. 다른 닉네임을 사용해주세요",
    ALREADY_EXISTING_PHONE_NUMBER: "입력하신 휴대폰 번호는 이미 가입된 회원입니다.",
    INVALID_PHONE_NUMBER_FORMAT: "번호를 올바르게 입력해주세요",
    INVALID_AUTH_CODE: "인증번호가 일치하지 않습니다. 다시 확인해주세요.",
    ALREADY_JOINED_CHAT_ROOM: "이미 참여한 채팅방입니다.",
    TIMESPREAD_STATUS_REQUIRE_PARAMETER: "필요 파리미터 누락",
    TIMESPREAD_STATUS_OBJECT_NOT_EXIST: "일치하는 대상 없음",
    TIMESPREAD_STATUS_PHONE_ALREADY_AUTHORIZE: "이미 인증된 핸드폰 번호입니다.",
    TIMESPREAD_STATUS_PHONE_CODE_REQUEST_EXCEED: "휴대폰 인증 코드 요청 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_CODE_DATA_NOT_FOUND: "휴대폰 인증 코드 데이터 없음",
    TIMESPREAD_STATUS_PHONE_FAIL_AUTHORIZE: "휴대폰 인증에 실패 하였습니다.",
    TIMESPREAD_STATUS_PHONE_REQUEST_EXCEED: "휴대폰 인증 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_NOT_ACCEPTED_IP: "허용되지 않은 IP",
    TIMESPREAD_STATUS_PHONE_USER_DELETE: "탈퇴 후 7일 이후부터 휴대폰 인증 가능",
    TIMESPREAD_STATUS_LUCKYBOX_LIMIT_EXCEED: "행운상자 개수 초과",
    TIMESPREAD_STATUS_LUCKYBOX_NEED_CASH: "행운상자 도전 최소 캐시 필요",
    TIMESPREAD_STATUS_LUCKYBOX_ALREADY_OPEN: "이미 오픈된 상자",
    TIMESPREAD_STATUS_SCREEN_ALREADY_FINISH: "이미 종료된 꽉 잠금 모드"
});


/***/ }),

/***/ 96597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29229);


function useErrorSnackbar() {
    var enqueueApolloError = function enqueueApolloError(error) {
        enqueueSnackbar((0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e$)(error), {
            // @ts-ignore
            "data-testid": "snackbar-apollo-error",
            // @ts-ignore
            "data-error-code": (0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCode */ .zg)(error)
        });
    };
    var enqueueErrorMessage = function enqueueErrorMessage(message) {
        enqueueSnackbar(message, {
            // @ts-ignore
            "data-testid": "snackbar-message-error"
        });
    };
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    return {
        enqueueApolloError: enqueueApolloError,
        enqueueErrorMessage: enqueueErrorMessage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useErrorSnackbar);


/***/ }),

/***/ 46399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var DefaultChannelLogoIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        "aria-label": "기본채널로고"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "기본채널로고"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h64v64H0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#c9c9c9",
                d: "M32.417 9.812l13.327 5.669v39.517H32.417zM46.292 26.21L58 33.51v21.488H46.292zM31.947 9.812l-17.061 5.669v39.517h17.061zM14.218 33.251l-8.211 2.728V55h8.211z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M22.562 16.265l-4.978 1.575v3.884l4.978-1.571zM9.706 36.888l-2.4.758v1.869l2.4-.756zM22.562 21.726l-4.978 1.575v3.884l4.978-1.571zM9.706 39.513l-2.4.758v1.869l2.4-.756zM22.562 26.945l-4.978 1.575v3.884l4.978-1.571zM9.706 42.027l-2.4.758v1.869l2.4-.756zM22.562 32.406l-4.978 1.575v3.884l4.978-1.571zM9.706 44.654l-2.4.758v1.869l2.4-.756zM22.562 37.863l-4.978 1.575v3.884l4.978-1.571zM28.678 14.384L23.7 15.959v3.884l4.978-1.571zM12.649 35.982l-2.4.758v1.869l2.4-.756zM28.678 19.843L23.7 21.418v3.884l4.978-1.571zM12.649 38.611l-2.4.758v1.869l2.4-.756zM28.678 25.064L23.7 26.639v3.884l4.978-1.571zM12.649 41.123l-2.4.758v1.869l2.4-.756zM28.678 30.523L23.7 32.098v3.884l4.978-1.571zM12.649 43.748l-2.4.758v1.869l2.4-.756zM12.649 46.377l-2.4.758v1.869l2.4-.756zM28.678 35.982L23.7 37.557v3.884l4.978-1.571zM48.693 32.291l1.783 1.112v3.272l-1.783-1.087zM48.693 40.943l1.783 1.112v3.272l-1.783-1.087zM48.693 36.558l1.783 1.112v3.272l-1.783-1.087zM51.254 33.998l1.783 1.112v3.272l-1.783-1.087zM51.254 42.65l1.783 1.112v3.272l-1.783-1.087zM51.254 38.267l1.783 1.112v3.272l-1.783-1.087zM53.816 35.705l1.783 1.112v3.272l-1.783-1.087zM53.816 44.359l1.783 1.112v3.272l-1.783-1.087zM53.816 39.974l1.783 1.112v3.272l-1.783-1.087z"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultChannelLogoIcon);


/***/ }),

/***/ 46095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ErrorIcon = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
            fill: "black"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorIcon);


/***/ }),

/***/ 56031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Like(param) {
    var _color = param.color, color = _color === void 0 ? "#777" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-label": "좋아요",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "좋아요"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "o4n8p4j35a",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "none",
                        d: "M0 0h16v16H0z",
                        "data-name": "사각형 3073"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z",
                "data-name": "사각형 7544"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "data-name": "그룹 9774",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#o4n8p4j35a)",
                    "data-name": "그룹 1312",
                    transform: "translate(4 4)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: color,
                            d: "M4.724 13.777h-2.9a.8.8 0 01-.8-.8V7.446a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.8",
                            "data-name": "패스 581"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "none",
                            stroke: color,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            strokeWidth: "1.2",
                            d: "M5.738 7.242a.447.447 0 00.221-.215 17.419 17.419 0 01.8-1.553 17.911 17.911 0 00.833-1.625 18.312 18.312 0 00-.154-2.067.606.606 0 01.321-.6 1.522 1.522 0 01.669-.159 1.638 1.638 0 011.424.892 3.69 3.69 0 01.405 2.855 18.2 18.2 0 00-.129.692h3.136a.6.6 0 01.153.019 1.507 1.507 0 011.025 2.309 1.507 1.507 0 01-.291 2.239 1.53 1.53 0 01.081.49 1.511 1.511 0 01-.818 1.341 1.605 1.605 0 01.025.277 1.511 1.511 0 01-1.509 1.509H7.037a.616.616 0 01-.164-.022c-.028-.009-1.135-.19-1.135-.19l-.333-.033m-.681.375h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805zm0 0h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805zm0 0h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805z",
                            "data-name": "패스 582"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Like);


/***/ }),

/***/ 32685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ShareLight(param) {
    var _color = param.color, color = _color === void 0 ? "#777" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "공유",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "공유"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "j0vm8zlzra",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        stroke: color,
                        d: "M0 0h20v20H0z",
                        "data-name": "사각형 3303",
                        transform: "translate(1432.5 570.5)"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#j0vm8zlzra)",
                "data-name": "마스크 그룹 98",
                transform: "translate(-1432.5 -570.5)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    "data-name": "share-2 (1)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "none",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.2",
                        d: "M1444 585.1a2 2 0 112 2 2 2 0 01-2-2zm-4.239-3.6a2 2 0 11.239-.95 2 2 0 01-.24.951l4.52 2.568zm4.479-4.549A2 2 0 111446 578a1.99 1.99 0 01-1.76-1.049l-4.513 2.568z",
                        "data-name": "합치기 92"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShareLight);


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "zg": function() { return /* binding */ getErrorCode; }
/* harmony export */ });
/* unused harmony export getErrorMessageFromServer */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65155);


var getErrorCode = function(error) {
    var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, "graphQLErrors[0].extensions.code", "UNKNOWN_ERROR");
    return errorCode;
};
var getErrorMessage = function(error) {
    var errorCode = getErrorCode(error);
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, errorCode, _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UNKNOWN_ERROR */ .Z.UNKNOWN_ERROR);
    return message;
};
var getErrorMessageFromServer = function(error) {
    var message = get(error, "graphQLErrors[0].message", errorMessages.UNKNOWN_ERROR);
    return message;
};


/***/ })

}]);